
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire73bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire73bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("l7VLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6170f1a08d72585$export$2e2bcd8739ae039);
/**
 * @module ol/geom/Circle
 */ 
var $h7zsK = parcelRequire("h7zsK");

var $9pD6L = parcelRequire("9pD6L");

var $9bJty = parcelRequire("9bJty");

var $1MAUi = parcelRequire("1MAUi");
/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */ class $f6170f1a08d72585$var$Circle extends (0, $h7zsK.default) {
    /**
   * @param {!import("../coordinate.js").Coordinate} center Center.
   *     For internal use, flat coordinates in combination with `layout` and no
   *     `radius` are also accepted.
   * @param {number} [radius] Radius in units of the projection.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(center, radius, layout){
        super();
        if (layout !== undefined && radius === undefined) this.setFlatCoordinates(layout, center);
        else {
            radius = radius ? radius : 0;
            this.setCenterAndRadius(center, radius, layout);
        }
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Circle} Clone.
   * @api
   */ clone() {
        const circle = new $f6170f1a08d72585$var$Circle(this.flatCoordinates.slice(), undefined, this.layout);
        circle.applyProperties(this);
        return circle;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        const squaredDistance = dx * dx + dy * dy;
        if (squaredDistance < minSquaredDistance) {
            if (squaredDistance === 0) for(let i = 0; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            else {
                const delta = this.getRadius() / Math.sqrt(squaredDistance);
                closestPoint[0] = flatCoordinates[0] + delta * dx;
                closestPoint[1] = flatCoordinates[1] + delta * dy;
                for(let i = 2; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            }
            closestPoint.length = this.stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        return dx * dx + dy * dy <= this.getRadiusSquared_();
    }
    /**
   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @return {import("../coordinate.js").Coordinate} Center.
   * @api
   */ getCenter() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const radius = flatCoordinates[this.stride] - flatCoordinates[0];
        return (0, $9pD6L.createOrUpdate)(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
    }
    /**
   * Return the radius of the circle.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return Math.sqrt(this.getRadiusSquared_());
    }
    /**
   * @private
   * @return {number} Radius squared.
   */ getRadiusSquared_() {
        const dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
        const dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
        return dx * dx + dy * dy;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "Circle";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        const circleExtent = this.getExtent();
        if ((0, $9pD6L.intersects)(extent, circleExtent)) {
            const center = this.getCenter();
            if (extent[0] <= center[0] && extent[2] >= center[0]) return true;
            if (extent[1] <= center[1] && extent[3] >= center[1]) return true;
            return (0, $9pD6L.forEachCorner)(extent, this.intersectsCoordinate.bind(this));
        }
        return false;
    }
    /**
   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @api
   */ setCenter(center) {
        const stride = this.stride;
        const radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
        const flatCoordinates = center.slice();
        flatCoordinates[stride] = flatCoordinates[0] + radius;
        for(let i = 1; i < stride; ++i)flatCoordinates[stride + i] = center[i];
        this.setFlatCoordinates(this.layout, flatCoordinates);
        this.changed();
    }
    /**
   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
   * number) of the circle.
   * @param {!import("../coordinate.js").Coordinate} center Center.
   * @param {number} radius Radius.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCenterAndRadius(center, radius, layout) {
        this.setLayout(layout, center, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        /** @type {Array<number>} */ const flatCoordinates = this.flatCoordinates;
        let offset = (0, $9bJty.deflateCoordinate)(flatCoordinates, 0, center, this.stride);
        flatCoordinates[offset++] = flatCoordinates[0] + radius;
        for(let i = 1, ii = this.stride; i < ii; ++i)flatCoordinates[offset++] = flatCoordinates[i];
        flatCoordinates.length = offset;
        this.changed();
    }
    getCoordinates() {
        return null;
    }
    setCoordinates(coordinates, layout) {}
    /**
   * Set the radius of the circle. The radius is in the units of the projection.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
        this.changed();
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        const center = this.getCenter();
        const stride = this.getStride();
        this.setCenter((0, $1MAUi.rotate)(center, 0, center.length, stride, angle, anchor, center));
        this.changed();
    }
}
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */ $f6170f1a08d72585$var$Circle.prototype.transform;
var $f6170f1a08d72585$export$2e2bcd8739ae039 = $f6170f1a08d72585$var$Circle;

});

parcelRegister("bV0pP", function(module, exports) {

$parcel$export(module.exports, "OLCS_ION_TOKEN", () => $8ad5571f7dcc7a1a$export$97f9922ccba1277f);
const $8ad5571f7dcc7a1a$export$97f9922ccba1277f = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3ZWVhYmU0Mi1jNTZkLTQ3OGItYmUxYS00YTMyMDQyZTMwNDkiLCJpZCI6NjQ1LCJpYXQiOjE2MDYxMjE2OTF9.zQibbf5P0-moQ8KiV_K7KMtyLHbR-VlPghj8lyqWduU";

});


var $cc3xD = parcelRequire("cc3xD");

var $9DiKA = parcelRequire("9DiKA");

var $f3WAG = parcelRequire("f3WAG");

var $9jDAx = parcelRequire("9jDAx");

var $4mWlF = parcelRequire("4mWlF");

var $cJntk = parcelRequire("cJntk");

var $bmHVE = parcelRequire("bmHVE");

var $c3RIb = parcelRequire("c3RIb");

var $9vPkX = parcelRequire("9vPkX");

var $dIG9p = parcelRequire("dIG9p");

var $lrKvI = parcelRequire("lrKvI");

var $jzydl = parcelRequire("jzydl");

var $inIMS = parcelRequire("inIMS");

var $5DwXE = parcelRequire("5DwXE");

var $l7VLp = parcelRequire("l7VLp");
/**
 * @module ol/format/TopoJSON
 */ 
var $dIG9p = parcelRequire("dIG9p");

var $45uGP = parcelRequire("45uGP");

var $3xcD3 = parcelRequire("3xcD3");

var $fw94T = parcelRequire("fw94T");

var $jKs1i = parcelRequire("jKs1i");

var $le5ya = parcelRequire("le5ya");

var $9vPkX = parcelRequire("9vPkX");

var $5ydre = parcelRequire("5ydre");

var $dpRHA = parcelRequire("dpRHA");

var $kgouC = parcelRequire("kgouC");
/**
 * @typedef {import("topojson-specification").Topology} TopoJSONTopology
 * @typedef {import("topojson-specification").GeometryCollection} TopoJSONGeometryCollection
 * @typedef {import("topojson-specification").GeometryObject} TopoJSONGeometry
 * @typedef {import("topojson-specification").Point} TopoJSONPoint
 * @typedef {import("topojson-specification").MultiPoint} TopoJSONMultiPoint
 * @typedef {import("topojson-specification").LineString} TopoJSONLineString
 * @typedef {import("topojson-specification").MultiLineString} TopoJSONMultiLineString
 * @typedef {import("topojson-specification").Polygon} TopoJSONPolygon
 * @typedef {import("topojson-specification").MultiPolygon} TopoJSONMultiPolygon
 */ /**
 * @typedef {Object} Options
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {string} [layerName] Set the name of the TopoJSON topology
 * `objects`'s children as feature property with the specified name. This means
 * that when set to `'layer'`, a topology like
 * ```
 * {
 *   "type": "Topology",
 *   "objects": {
 *     "example": {
 *       "type": "GeometryCollection",
 *       "geometries": []
 *     }
 *   }
 * }
 * ```
 * will result in features that have a property `'layer'` set to `'example'`.
 * When not set, no property will be added to features.
 * @property {Array<string>} [layers] Names of the TopoJSON topology's
 * `objects`'s children to read features from.  If not provided, features will
 * be read from all children.
 */ /**
 * @classdesc
 * Feature format for reading data in the TopoJSON format.
 *
 * @api
 */ class $10d5bd550e039cbe$var$TopoJSON extends (0, $45uGP.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {string|undefined}
     */ this.layerName_ = options.layerName;
        /**
     * @private
     * @type {?Array<string>}
     */ this.layers_ = options.layers ? options.layers : null;
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $dpRHA.get)(options.dataProjection ? options.dataProjection : "EPSG:4326");
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<Feature>} Features.
   */ readFeaturesFromObject(object, options) {
        if (object.type == "Topology") {
            const topoJSONTopology = /** @type {TopoJSONTopology} */ object;
            let transform, scale = null, translate = null;
            if (topoJSONTopology["transform"]) {
                transform = topoJSONTopology["transform"];
                scale = transform["scale"];
                translate = transform["translate"];
            }
            const arcs = topoJSONTopology["arcs"];
            if (transform) $10d5bd550e039cbe$var$transformArcs(arcs, scale, translate);
            /** @type {Array<Feature>} */ const features = [];
            const topoJSONFeatures = topoJSONTopology["objects"];
            const property = this.layerName_;
            let feature;
            for(const objectName in topoJSONFeatures){
                if (this.layers_ && !this.layers_.includes(objectName)) continue;
                if (topoJSONFeatures[objectName].type === "GeometryCollection") {
                    feature = /** @type {TopoJSONGeometryCollection} */ topoJSONFeatures[objectName];
                    features.push.apply(features, $10d5bd550e039cbe$var$readFeaturesFromGeometryCollection(feature, arcs, scale, translate, property, objectName, options));
                } else {
                    feature = /** @type {TopoJSONGeometry} */ topoJSONFeatures[objectName];
                    features.push($10d5bd550e039cbe$var$readFeatureFromGeometry(feature, arcs, scale, translate, property, objectName, options));
                }
            }
            return features;
        }
        return [];
    }
    /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromObject(object) {
        return this.dataProjection;
    }
}
/**
 * @const
 * @type {Object<string, function(TopoJSONGeometry, Array, ...Array=): import("../geom/Geometry.js").default>}
 */ const $10d5bd550e039cbe$var$GEOMETRY_READERS = {
    "Point": $10d5bd550e039cbe$var$readPointGeometry,
    "LineString": $10d5bd550e039cbe$var$readLineStringGeometry,
    "Polygon": $10d5bd550e039cbe$var$readPolygonGeometry,
    "MultiPoint": $10d5bd550e039cbe$var$readMultiPointGeometry,
    "MultiLineString": $10d5bd550e039cbe$var$readMultiLineStringGeometry,
    "MultiPolygon": $10d5bd550e039cbe$var$readMultiPolygonGeometry
};
/**
 * Concatenate arcs into a coordinate array.
 * @param {Array<number>} indices Indices of arcs to concatenate.  Negative
 *     values indicate arcs need to be reversed.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs (already
 *     transformed).
 * @return {Array<import("../coordinate.js").Coordinate>} Coordinates array.
 */ function $10d5bd550e039cbe$var$concatenateArcs(indices, arcs) {
    /** @type {Array<import("../coordinate.js").Coordinate>} */ const coordinates = [];
    let index;
    for(let i = 0, ii = indices.length; i < ii; ++i){
        index = indices[i];
        if (i > 0) // splicing together arcs, discard last point
        coordinates.pop();
        if (index >= 0) {
            // forward arc
            const arc = arcs[index];
            for(let j = 0, jj = arc.length; j < jj; ++j)coordinates.push(arc[j].slice(0));
        } else {
            // reverse arc
            const arc = arcs[~index];
            for(let j = arc.length - 1; j >= 0; --j)coordinates.push(arc[j].slice(0));
        }
    }
    return coordinates;
}
/**
 * Create a point from a TopoJSON geometry object.
 *
 * @param {TopoJSONPoint} object TopoJSON object.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 * @return {Point} Geometry.
 */ function $10d5bd550e039cbe$var$readPointGeometry(object, scale, translate) {
    const coordinates = object["coordinates"];
    if (scale && translate) $10d5bd550e039cbe$var$transformVertex(coordinates, scale, translate);
    return new (0, $9vPkX.default)(coordinates);
}
/**
 * Create a multi-point from a TopoJSON geometry object.
 *
 * @param {TopoJSONMultiPoint} object TopoJSON object.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 * @return {MultiPoint} Geometry.
 */ function $10d5bd550e039cbe$var$readMultiPointGeometry(object, scale, translate) {
    const coordinates = object["coordinates"];
    if (scale && translate) for(let i = 0, ii = coordinates.length; i < ii; ++i)$10d5bd550e039cbe$var$transformVertex(coordinates[i], scale, translate);
    return new (0, $jKs1i.default)(coordinates);
}
/**
 * Create a linestring from a TopoJSON geometry object.
 *
 * @param {TopoJSONLineString} object TopoJSON object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @return {LineString} Geometry.
 */ function $10d5bd550e039cbe$var$readLineStringGeometry(object, arcs) {
    const coordinates = $10d5bd550e039cbe$var$concatenateArcs(object["arcs"], arcs);
    return new (0, $3xcD3.default)(coordinates);
}
/**
 * Create a multi-linestring from a TopoJSON geometry object.
 *
 * @param {TopoJSONMultiLineString} object TopoJSON object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @return {MultiLineString} Geometry.
 */ function $10d5bd550e039cbe$var$readMultiLineStringGeometry(object, arcs) {
    const coordinates = [];
    for(let i = 0, ii = object["arcs"].length; i < ii; ++i)coordinates[i] = $10d5bd550e039cbe$var$concatenateArcs(object["arcs"][i], arcs);
    return new (0, $fw94T.default)(coordinates);
}
/**
 * Create a polygon from a TopoJSON geometry object.
 *
 * @param {TopoJSONPolygon} object TopoJSON object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @return {Polygon} Geometry.
 */ function $10d5bd550e039cbe$var$readPolygonGeometry(object, arcs) {
    const coordinates = [];
    for(let i = 0, ii = object["arcs"].length; i < ii; ++i)coordinates[i] = $10d5bd550e039cbe$var$concatenateArcs(object["arcs"][i], arcs);
    return new (0, $5ydre.default)(coordinates);
}
/**
 * Create a multi-polygon from a TopoJSON geometry object.
 *
 * @param {TopoJSONMultiPolygon} object TopoJSON object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @return {MultiPolygon} Geometry.
 */ function $10d5bd550e039cbe$var$readMultiPolygonGeometry(object, arcs) {
    const coordinates = [];
    for(let i = 0, ii = object["arcs"].length; i < ii; ++i){
        // for each polygon
        const polyArray = object["arcs"][i];
        const ringCoords = [];
        for(let j = 0, jj = polyArray.length; j < jj; ++j)// for each ring
        ringCoords[j] = $10d5bd550e039cbe$var$concatenateArcs(polyArray[j], arcs);
        coordinates[i] = ringCoords;
    }
    return new (0, $le5ya.default)(coordinates);
}
/**
 * Create features from a TopoJSON GeometryCollection object.
 *
 * @param {TopoJSONGeometryCollection} collection TopoJSON Geometry
 *     object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 * @param {string|undefined} property Property to set the `GeometryCollection`'s parent
 *     object to.
 * @param {string} name Name of the `Topology`'s child object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {Array<Feature>} Array of features.
 */ function $10d5bd550e039cbe$var$readFeaturesFromGeometryCollection(collection, arcs, scale, translate, property, name, options) {
    const geometries = collection["geometries"];
    const features = [];
    for(let i = 0, ii = geometries.length; i < ii; ++i)features[i] = $10d5bd550e039cbe$var$readFeatureFromGeometry(geometries[i], arcs, scale, translate, property, name, options);
    return features;
}
/**
 * Create a feature from a TopoJSON geometry object.
 *
 * @param {TopoJSONGeometry} object TopoJSON geometry object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 * @param {string|undefined} property Property to set the `GeometryCollection`'s parent
 *     object to.
 * @param {string} name Name of the `Topology`'s child object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {Feature} Feature.
 */ function $10d5bd550e039cbe$var$readFeatureFromGeometry(object, arcs, scale, translate, property, name, options) {
    let geometry = null;
    const type = object.type;
    if (type) {
        const geometryReader = $10d5bd550e039cbe$var$GEOMETRY_READERS[type];
        if (type === "Point" || type === "MultiPoint") geometry = geometryReader(object, scale, translate);
        else geometry = geometryReader(object, arcs);
        geometry = (0, $kgouC.transformGeometryWithOptions)(geometry, false, options);
    }
    const feature = new (0, $dIG9p.default)({
        geometry: geometry
    });
    if (object.id !== undefined) feature.setId(object.id);
    let properties = object.properties;
    if (property) {
        if (!properties) properties = {};
        properties[property] = name;
    }
    if (properties) feature.setProperties(properties, true);
    return feature;
}
/**
 * Apply a linear transform to array of arcs.  The provided array of arcs is
 * modified in place.
 *
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 */ function $10d5bd550e039cbe$var$transformArcs(arcs, scale, translate) {
    for(let i = 0, ii = arcs.length; i < ii; ++i)$10d5bd550e039cbe$var$transformArc(arcs[i], scale, translate);
}
/**
 * Apply a linear transform to an arc.  The provided arc is modified in place.
 *
 * @param {Array<import("../coordinate.js").Coordinate>} arc Arc.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 */ function $10d5bd550e039cbe$var$transformArc(arc, scale, translate) {
    let x = 0;
    let y = 0;
    for(let i = 0, ii = arc.length; i < ii; ++i){
        const vertex = arc[i];
        x += vertex[0];
        y += vertex[1];
        vertex[0] = x;
        vertex[1] = y;
        $10d5bd550e039cbe$var$transformVertex(vertex, scale, translate);
    }
}
/**
 * Apply a linear transform to a vertex.  The provided vertex is modified in
 * place.
 *
 * @param {import("../coordinate.js").Coordinate} vertex Vertex.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 */ function $10d5bd550e039cbe$var$transformVertex(vertex, scale, translate) {
    vertex[0] = vertex[0] * scale[0] + translate[0];
    vertex[1] = vertex[1] * scale[1] + translate[1];
}
var $10d5bd550e039cbe$export$2e2bcd8739ae039 = $10d5bd550e039cbe$var$TopoJSON;



var $wnhPR = parcelRequire("wnhPR");
/**
 * @module ol/format/KML
 */ 
var $dIG9p = parcelRequire("dIG9p");

var $inIMS = parcelRequire("inIMS");

var $1eatv = parcelRequire("1eatv");

var $bmHVE = parcelRequire("bmHVE");

var $aSvtr = parcelRequire("aSvtr");

var $3xcD3 = parcelRequire("3xcD3");

var $fw94T = parcelRequire("fw94T");

var $jKs1i = parcelRequire("jKs1i");

var $le5ya = parcelRequire("le5ya");

var $9vPkX = parcelRequire("9vPkX");

var $5ydre = parcelRequire("5ydre");

var $lrKvI = parcelRequire("lrKvI");

var $c3RIb = parcelRequire("c3RIb");

var $cJntk = parcelRequire("cJntk");
/**
 * @module ol/format/XMLFeature
 */ 
var $kgouC = parcelRequire("kgouC");

var $9iPUS = parcelRequire("9iPUS");

var $fVVyM = parcelRequire("fVVyM");
/**
 * @module ol/xml
 */ 
var $fVVyM = parcelRequire("fVVyM");
const $a4f89edd2ef65182$export$be284679de3fbea8 = "http://www.w3.org/2001/XMLSchema-instance";
function $a4f89edd2ef65182$export$7094a064528c7fee(namespaceURI, qualifiedName) {
    return $a4f89edd2ef65182$export$f65ca476c09acec0().createElementNS(namespaceURI, qualifiedName);
}
function $a4f89edd2ef65182$export$b089dda0fde13047(node, normalizeWhitespace) {
    return $a4f89edd2ef65182$export$caa0047a9c11e135(node, normalizeWhitespace, []).join("");
}
function $a4f89edd2ef65182$export$caa0047a9c11e135(node, normalizeWhitespace, accumulator) {
    if (node.nodeType == Node.CDATA_SECTION_NODE || node.nodeType == Node.TEXT_NODE) {
        if (normalizeWhitespace) accumulator.push(String(node.nodeValue).replace(/(\r\n|\r|\n)/g, ""));
        else accumulator.push(node.nodeValue);
    } else {
        let n;
        for(n = node.firstChild; n; n = n.nextSibling)$a4f89edd2ef65182$export$caa0047a9c11e135(n, normalizeWhitespace, accumulator);
    }
    return accumulator;
}
function $a4f89edd2ef65182$export$62858bae88b53fd0(object) {
    return "documentElement" in object;
}
function $a4f89edd2ef65182$export$199b05d6829fbbad(node, namespaceURI, name) {
    return node.getAttributeNS(namespaceURI, name) || "";
}
function $a4f89edd2ef65182$export$98e6a39c04603d36(xml) {
    return new DOMParser().parseFromString(xml, "application/xml");
}
function $a4f89edd2ef65182$export$b2d5eb949eb55a2a(valueReader, thisArg) {
    return(/**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     */ function(node, objectStack) {
        const value = valueReader.call(thisArg !== undefined ? thisArg : this, node, objectStack);
        if (value !== undefined) {
            const array = /** @type {Array<*>} */ objectStack[objectStack.length - 1];
            (0, $fVVyM.extend)(array, value);
        }
    });
}
function $a4f89edd2ef65182$export$18ed2f5932a1b385(valueReader, thisArg) {
    return(/**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */ function(node, objectStack) {
        const value = valueReader.call(thisArg !== undefined ? thisArg : this, node, objectStack);
        if (value !== undefined) {
            const array = /** @type {Array<*>} */ objectStack[objectStack.length - 1];
            array.push(value);
        }
    });
}
function $a4f89edd2ef65182$export$b1b80676c57c5713(valueReader, thisArg) {
    return(/**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     */ function(node, objectStack) {
        const value = valueReader.call(thisArg !== undefined ? thisArg : this, node, objectStack);
        if (value !== undefined) objectStack[objectStack.length - 1] = value;
    });
}
function $a4f89edd2ef65182$export$145ce5485ab74220(valueReader, property, thisArg) {
    return(/**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */ function(node, objectStack) {
        const value = valueReader.call(thisArg !== undefined ? thisArg : this, node, objectStack);
        if (value !== undefined) {
            const object = /** @type {!Object} */ objectStack[objectStack.length - 1];
            const name = property !== undefined ? property : node.localName;
            let array;
            if (name in object) array = object[name];
            else {
                array = [];
                object[name] = array;
            }
            array.push(value);
        }
    });
}
function $a4f89edd2ef65182$export$b69a91976ee81208(valueReader, property, thisArg) {
    return(/**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */ function(node, objectStack) {
        const value = valueReader.call(thisArg !== undefined ? thisArg : this, node, objectStack);
        if (value !== undefined) {
            const object = /** @type {!Object} */ objectStack[objectStack.length - 1];
            const name = property !== undefined ? property : node.localName;
            object[name] = value;
        }
    });
}
function $a4f89edd2ef65182$export$77b73fc7f982cc07(nodeWriter, thisArg) {
    return function(node, value, objectStack) {
        nodeWriter.call(thisArg !== undefined ? thisArg : this, node, value, objectStack);
        const parent = /** @type {NodeStackItem} */ objectStack[objectStack.length - 1];
        const parentNode = parent.node;
        parentNode.appendChild(node);
    };
}
function $a4f89edd2ef65182$export$fa227189764d6986(nodeWriter, thisArg) {
    let serializersNS, nodeFactory;
    return function(node, value, objectStack) {
        if (serializersNS === undefined) {
            serializersNS = {};
            const serializers = {};
            serializers[node.localName] = nodeWriter;
            serializersNS[node.namespaceURI] = serializers;
            nodeFactory = $a4f89edd2ef65182$export$7989129829daaabf(node.localName);
        }
        $a4f89edd2ef65182$export$dfdc1655ccc5b9cb(serializersNS, nodeFactory, value, objectStack);
    };
}
function $a4f89edd2ef65182$export$7989129829daaabf(fixedNodeName, fixedNamespaceURI) {
    return(/**
     * @param {*} value Value.
     * @param {Array<*>} objectStack Object stack.
     * @param {string} [newNodeName] Node name.
     * @return {Node} Node.
     */ function(value, objectStack, newNodeName) {
        const context = /** @type {NodeStackItem} */ objectStack[objectStack.length - 1];
        const node = context.node;
        let nodeName = fixedNodeName;
        if (nodeName === undefined) nodeName = newNodeName;
        const namespaceURI = fixedNamespaceURI !== undefined ? fixedNamespaceURI : node.namespaceURI;
        return $a4f89edd2ef65182$export$7094a064528c7fee(namespaceURI, /** @type {string} */ nodeName);
    });
}
const $a4f89edd2ef65182$export$d91b08b611cef144 = $a4f89edd2ef65182$export$7989129829daaabf();
function $a4f89edd2ef65182$export$939885a13683f4dc(object, orderedKeys) {
    const length = orderedKeys.length;
    const sequence = new Array(length);
    for(let i = 0; i < length; ++i)sequence[i] = object[orderedKeys[i]];
    return sequence;
}
function $a4f89edd2ef65182$export$c6eb0402f939765f(namespaceURIs, structure, structureNS) {
    structureNS = structureNS !== undefined ? structureNS : {};
    let i, ii;
    for(i = 0, ii = namespaceURIs.length; i < ii; ++i)structureNS[namespaceURIs[i]] = structure;
    return structureNS;
}
function $a4f89edd2ef65182$export$dc8ce45ce1679f4f(parsersNS, node, objectStack, thisArg) {
    let n;
    for(n = node.firstElementChild; n; n = n.nextElementSibling){
        const parsers = parsersNS[n.namespaceURI];
        if (parsers !== undefined) {
            const parser = parsers[n.localName];
            if (parser !== undefined) parser.call(thisArg, n, objectStack);
        }
    }
}
function $a4f89edd2ef65182$export$5c934df85741dbd1(object, parsersNS, node, objectStack, thisArg) {
    objectStack.push(object);
    $a4f89edd2ef65182$export$dc8ce45ce1679f4f(parsersNS, node, objectStack, thisArg);
    return /** @type {T} */ objectStack.pop();
}
function $a4f89edd2ef65182$export$dfdc1655ccc5b9cb(serializersNS, nodeFactory, values, objectStack, keys, thisArg) {
    const length = (keys !== undefined ? keys : values).length;
    let value, node;
    for(let i = 0; i < length; ++i){
        value = values[i];
        if (value !== undefined) {
            node = nodeFactory.call(thisArg !== undefined ? thisArg : this, value, objectStack, keys !== undefined ? keys[i] : undefined);
            if (node !== undefined) serializersNS[node.namespaceURI][node.localName].call(thisArg, node, value, objectStack);
        }
    }
}
function $a4f89edd2ef65182$export$a79a01f4edad8da8(object, serializersNS, nodeFactory, values, objectStack, keys, thisArg) {
    objectStack.push(object);
    $a4f89edd2ef65182$export$dfdc1655ccc5b9cb(serializersNS, nodeFactory, values, objectStack, keys, thisArg);
    return /** @type {O|undefined} */ objectStack.pop();
}
let $a4f89edd2ef65182$var$xmlSerializer_ = undefined;
function $a4f89edd2ef65182$export$6d77e0eada4b836a(xmlSerializer) {
    $a4f89edd2ef65182$var$xmlSerializer_ = xmlSerializer;
}
function $a4f89edd2ef65182$export$e087df39da12b01f() {
    if ($a4f89edd2ef65182$var$xmlSerializer_ === undefined && typeof XMLSerializer !== "undefined") $a4f89edd2ef65182$var$xmlSerializer_ = new XMLSerializer();
    return $a4f89edd2ef65182$var$xmlSerializer_;
}
let $a4f89edd2ef65182$var$document_ = undefined;
function $a4f89edd2ef65182$export$4bebdef07101fbd4(document1) {
    $a4f89edd2ef65182$var$document_ = document1;
}
function $a4f89edd2ef65182$export$f65ca476c09acec0() {
    if ($a4f89edd2ef65182$var$document_ === undefined && typeof document !== "undefined") $a4f89edd2ef65182$var$document_ = document.implementation.createDocument("", "", null);
    return $a4f89edd2ef65182$var$document_;
}


/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for XML feature formats.
 *
 * @abstract
 */ class $ce16c3ce3167dc37$var$XMLFeature extends (0, $kgouC.default) {
    constructor(){
        super();
        /**
     * @type {XMLSerializer}
     * @private
     */ this.xmlSerializer_ = (0, $a4f89edd2ef65182$export$e087df39da12b01f)();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   */ getType() {
        return "xml";
    }
    /**
   * Read a single feature.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../Feature.js").default} Feature.
   * @api
   */ readFeature(source, options) {
        if (!source) return null;
        if (typeof source === "string") {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readFeatureFromDocument(doc, options);
        }
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readFeatureFromDocument(/** @type {Document} */ source, options);
        return this.readFeatureFromNode(/** @type {Element} */ source, options);
    }
    /**
   * @param {Document} doc Document.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {import("../Feature.js").default} Feature.
   */ readFeatureFromDocument(doc, options) {
        const features = this.readFeaturesFromDocument(doc, options);
        if (features.length > 0) return features[0];
        return null;
    }
    /**
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {import("../Feature.js").default} Feature.
   */ readFeatureFromNode(node, options) {
        return null; // not implemented
    }
    /**
   * Read all features from a feature collection.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */ readFeatures(source, options) {
        if (!source) return [];
        if (typeof source === "string") {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readFeaturesFromDocument(doc, options);
        }
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readFeaturesFromDocument(/** @type {Document} */ source, options);
        return this.readFeaturesFromNode(/** @type {Element} */ source, options);
    }
    /**
   * @param {Document} doc Document.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @protected
   * @return {Array<import("../Feature.js").default>} Features.
   */ readFeaturesFromDocument(doc, options) {
        /** @type {Array<import("../Feature.js").default>} */ const features = [];
        for(let n = doc.firstChild; n; n = n.nextSibling)if (n.nodeType == Node.ELEMENT_NODE) (0, $fVVyM.extend)(features, this.readFeaturesFromNode(/** @type {Element} */ n, options));
        return features;
    }
    /**
   * @abstract
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @protected
   * @return {Array<import("../Feature.js").default>} Features.
   */ readFeaturesFromNode(node, options) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Read a single geometry from a source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometry(source, options) {
        if (!source) return null;
        if (typeof source === "string") {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readGeometryFromDocument(doc, options);
        }
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readGeometryFromDocument(/** @type {Document} */ source, options);
        return this.readGeometryFromNode(/** @type {Element} */ source, options);
    }
    /**
   * @param {Document} doc Document.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromDocument(doc, options) {
        return null; // not implemented
    }
    /**
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromNode(node, options) {
        return null; // not implemented
    }
    /**
   * Read the projection from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   */ readProjection(source) {
        if (!source) return null;
        if (typeof source === "string") {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readProjectionFromDocument(doc);
        }
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readProjectionFromDocument(/** @type {Document} */ source);
        return this.readProjectionFromNode(/** @type {Element} */ source);
    }
    /**
   * @param {Document} doc Document.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromDocument(doc) {
        return this.dataProjection;
    }
    /**
   * @param {Element} node Node.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromNode(node) {
        return this.dataProjection;
    }
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   */ writeFeature(feature, options) {
        const node = this.writeFeatureNode(feature, options);
        return this.xmlSerializer_.serializeToString(node);
    }
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Options.
   * @protected
   * @return {Node} Node.
   */ writeFeatureNode(feature, options) {
        return null; // not implemented
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Result.
   * @api
   */ writeFeatures(features, options) {
        const node = this.writeFeaturesNode(features, options);
        return this.xmlSerializer_.serializeToString(node);
    }
    /**
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Options.
   * @return {Node} Node.
   */ writeFeaturesNode(features, options) {
        return null; // not implemented
    }
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   */ writeGeometry(geometry, options) {
        const node = this.writeGeometryNode(geometry, options);
        return this.xmlSerializer_.serializeToString(node);
    }
    /**
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Options.
   * @return {Node} Node.
   */ writeGeometryNode(geometry, options) {
        return null; // not implemented
    }
}
var $ce16c3ce3167dc37$export$2e2bcd8739ae039 = $ce16c3ce3167dc37$var$XMLFeature;




var $4iSHH = parcelRequire("4iSHH");

var $fVVyM = parcelRequire("fVVyM");

var $dpRHA = parcelRequire("dpRHA");
/**
 * @module ol/format/xsd
 */ 

var $lVIA6 = parcelRequire("lVIA6");
function $d5e0fde316cac971$export$f9a84177eae95ed5(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    return $d5e0fde316cac971$export$a8558234a836634(s);
}
function $d5e0fde316cac971$export$a8558234a836634(string) {
    const m = /^\s*(true|1)|(false|0)\s*$/.exec(string);
    if (m) return m[1] !== undefined || false;
    return undefined;
}
function $d5e0fde316cac971$export$5079def2140fe6f2(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    const dateTime = Date.parse(s);
    return isNaN(dateTime) ? undefined : dateTime / 1000;
}
function $d5e0fde316cac971$export$5be9c99d34ad295b(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    return $d5e0fde316cac971$export$5a7483b211367c0c(s);
}
function $d5e0fde316cac971$export$5a7483b211367c0c(string) {
    // FIXME check spec
    const m = /^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*$/i.exec(string);
    if (m) return parseFloat(m[1]);
    return undefined;
}
function $d5e0fde316cac971$export$6161a72ab5b6b722(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    return $d5e0fde316cac971$export$1c8fe3e9d3126f53(s);
}
function $d5e0fde316cac971$export$1c8fe3e9d3126f53(string) {
    const m = /^\s*(\d+)\s*$/.exec(string);
    if (m) return parseInt(m[1], 10);
    return undefined;
}
function $d5e0fde316cac971$export$dda73877cb166cd3(node) {
    return (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false).trim();
}
function $d5e0fde316cac971$export$9de8e8a584a450b7(node, bool) {
    $d5e0fde316cac971$export$3255ca5635e70aed(node, bool ? "1" : "0");
}
function $d5e0fde316cac971$export$d6c624180454e8f9(node, string) {
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createCDATASection(string));
}
function $d5e0fde316cac971$export$4e91791cb8677e27(node, dateTime) {
    const date = new Date(dateTime * 1000);
    const string = date.getUTCFullYear() + "-" + (0, $lVIA6.padNumber)(date.getUTCMonth() + 1, 2) + "-" + (0, $lVIA6.padNumber)(date.getUTCDate(), 2) + "T" + (0, $lVIA6.padNumber)(date.getUTCHours(), 2) + ":" + (0, $lVIA6.padNumber)(date.getUTCMinutes(), 2) + ":" + (0, $lVIA6.padNumber)(date.getUTCSeconds(), 2) + "Z";
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}
function $d5e0fde316cac971$export$f8009f9ca036d7d1(node, decimal) {
    const string = decimal.toPrecision();
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}
function $d5e0fde316cac971$export$b6c828910b813a07(node, nonNegativeInteger) {
    const string = nonNegativeInteger.toString();
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}
function $d5e0fde316cac971$export$3255ca5635e70aed(node, string) {
    node.appendChild((0, $a4f89edd2ef65182$export$f65ca476c09acec0)().createTextNode(string));
}



var $9byFX = parcelRequire("9byFX");

var $kgouC = parcelRequire("kgouC");
/**
 * @typedef {Object} Vec2
 * @property {number} x X coordinate.
 * @property {import("../style/Icon.js").IconAnchorUnits} xunits Units of x.
 * @property {number} y Y coordinate.
 * @property {import("../style/Icon.js").IconAnchorUnits} yunits Units of Y.
 * @property {import("../style/Icon.js").IconOrigin} [origin] Origin.
 */ /**
 * @typedef {Object} GxTrackObject
 * @property {Array<Array<number>>} coordinates Coordinates.
 * @property {Array<number>} whens Whens.
 */ /**
 * @const
 * @type {Array<string>}
 */ const $1140dfbeee585f32$var$GX_NAMESPACE_URIS = [
    "http://www.google.com/kml/ext/2.2"
];
/**
 * @const
 * @type {Array<null|string>}
 */ const $1140dfbeee585f32$var$NAMESPACE_URIS = [
    null,
    "http://earth.google.com/kml/2.0",
    "http://earth.google.com/kml/2.1",
    "http://earth.google.com/kml/2.2",
    "http://www.opengis.net/kml/2.2"
];
/**
 * @const
 * @type {string}
 */ const $1140dfbeee585f32$var$SCHEMA_LOCATION = "http://www.opengis.net/kml/2.2 https://developers.google.com/kml/schema/kml22gx.xsd";
/**
 * @type {Object<string, import("../style/Icon.js").IconAnchorUnits>}
 */ const $1140dfbeee585f32$var$ICON_ANCHOR_UNITS_MAP = {
    "fraction": "fraction",
    "pixels": "pixels",
    "insetPixels": "pixels"
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PLACEMARK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "ExtendedData": $1140dfbeee585f32$var$extendedDataParser,
    "Region": $1140dfbeee585f32$var$regionParser,
    "MultiGeometry": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readMultiGeometry, "geometry"),
    "LineString": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readLineString, "geometry"),
    "LinearRing": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readLinearRing, "geometry"),
    "Point": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readPoint, "geometry"),
    "Polygon": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readPolygon, "geometry"),
    "Style": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readStyle),
    "StyleMap": $1140dfbeee585f32$var$placemarkStyleMapParser,
    "address": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "description": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "name": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "open": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5)),
    "phoneNumber": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "styleUrl": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readStyleURL),
    "visibility": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5))
}, (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, {
    "MultiTrack": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readGxMultiTrack, "geometry"),
    "Track": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readGxTrack, "geometry")
}));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$NETWORK_LINK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "ExtendedData": $1140dfbeee585f32$var$extendedDataParser,
    "Region": $1140dfbeee585f32$var$regionParser,
    "Link": $1140dfbeee585f32$var$linkParser,
    "address": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "description": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "name": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "open": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5)),
    "phoneNumber": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "visibility": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5))
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LINK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "href": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readURI)
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$CAMERA_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    Altitude: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    Longitude: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    Latitude: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    Tilt: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    AltitudeMode: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    Heading: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    Roll: (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b))
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$REGION_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "LatLonAltBox": $1140dfbeee585f32$var$latLonAltBoxParser,
    "Lod": $1140dfbeee585f32$var$lodParser
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$KML_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    "Document",
    "Placemark"
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$KML_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "Document": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeDocument),
    "Placemark": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePlacemark)
});
/**
 * @type {import("../color.js").Color}
 */ let $1140dfbeee585f32$var$DEFAULT_COLOR;
/**
 * @type {Fill|null}
 */ let $1140dfbeee585f32$var$DEFAULT_FILL_STYLE = null;
function $1140dfbeee585f32$export$21e811a557b26b54() {
    return $1140dfbeee585f32$var$DEFAULT_FILL_STYLE;
}
/**
 * @type {import("../size.js").Size}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR;
/**
 * @type {import("../style/Icon.js").IconAnchorUnits}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
/**
 * @type {import("../style/Icon.js").IconAnchorUnits}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
/**
 * @type {import("../size.js").Size}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE;
/**
 * @type {string}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SRC;
/**
 * @type {import("../style/Image.js").default|null}
 */ let $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE = null;
function $1140dfbeee585f32$export$a17963acbf6c1558() {
    return $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE;
}
/**
 * @type {string}
 */ let $1140dfbeee585f32$var$DEFAULT_NO_IMAGE_STYLE;
/**
 * @type {Stroke|null}
 */ let $1140dfbeee585f32$var$DEFAULT_STROKE_STYLE = null;
function $1140dfbeee585f32$export$3207aea01810180d() {
    return $1140dfbeee585f32$var$DEFAULT_STROKE_STYLE;
}
/**
 * @type {Stroke}
 */ let $1140dfbeee585f32$var$DEFAULT_TEXT_STROKE_STYLE;
/**
 * @type {Text|null}
 */ let $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE = null;
function $1140dfbeee585f32$export$58459f1e3c16c230() {
    return $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE;
}
/**
 * @type {Style|null}
 */ let $1140dfbeee585f32$var$DEFAULT_STYLE = null;
function $1140dfbeee585f32$export$26ecbb5c9753d95f() {
    return $1140dfbeee585f32$var$DEFAULT_STYLE;
}
/**
 * @type {Array<Style>|null}
 */ let $1140dfbeee585f32$var$DEFAULT_STYLE_ARRAY = null;
function $1140dfbeee585f32$export$f1c529e822ec2fdc() {
    return $1140dfbeee585f32$var$DEFAULT_STYLE_ARRAY;
}
/**
 * Function that returns the scale needed to normalize an icon image to 32 pixels.
 * @param {import("../size.js").Size} size Image size.
 * @return {number} Scale.
 */ function $1140dfbeee585f32$var$scaleForSize(size) {
    return 32 / Math.min(size[0], size[1]);
}
function $1140dfbeee585f32$var$createStyleDefaults() {
    $1140dfbeee585f32$var$DEFAULT_COLOR = [
        255,
        255,
        255,
        1
    ];
    $1140dfbeee585f32$var$DEFAULT_FILL_STYLE = new (0, $inIMS.default)({
        color: $1140dfbeee585f32$var$DEFAULT_COLOR
    });
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR = [
        20,
        2
    ];
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS = "pixels";
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS = "pixels";
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE = [
        64,
        64
    ];
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SRC = "https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png";
    $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE = new (0, $bmHVE.default)({
        anchor: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR,
        anchorOrigin: "bottom-left",
        anchorXUnits: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS,
        anchorYUnits: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS,
        crossOrigin: "anonymous",
        rotation: 0,
        scale: $1140dfbeee585f32$var$scaleForSize($1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE),
        size: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE,
        src: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SRC
    });
    $1140dfbeee585f32$var$DEFAULT_NO_IMAGE_STYLE = "NO_IMAGE";
    $1140dfbeee585f32$var$DEFAULT_STROKE_STYLE = new (0, $lrKvI.default)({
        color: $1140dfbeee585f32$var$DEFAULT_COLOR,
        width: 1
    });
    $1140dfbeee585f32$var$DEFAULT_TEXT_STROKE_STYLE = new (0, $lrKvI.default)({
        color: [
            51,
            51,
            51,
            1
        ],
        width: 2
    });
    $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE = new (0, $cJntk.default)({
        font: "bold 16px Helvetica",
        fill: $1140dfbeee585f32$var$DEFAULT_FILL_STYLE,
        stroke: $1140dfbeee585f32$var$DEFAULT_TEXT_STROKE_STYLE,
        scale: 0.8
    });
    $1140dfbeee585f32$var$DEFAULT_STYLE = new (0, $c3RIb.default)({
        fill: $1140dfbeee585f32$var$DEFAULT_FILL_STYLE,
        image: $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE,
        text: $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE,
        stroke: $1140dfbeee585f32$var$DEFAULT_STROKE_STYLE,
        zIndex: 0
    });
    $1140dfbeee585f32$var$DEFAULT_STYLE_ARRAY = [
        $1140dfbeee585f32$var$DEFAULT_STYLE
    ];
}
/**
 * @type {HTMLTextAreaElement}
 */ let $1140dfbeee585f32$var$TEXTAREA;
/**
 * A function that takes a url `{string}` and returns a url `{string}`.
 * Might be used to change an icon path or to substitute a
 * data url obtained from a KMZ array buffer.
 *
 * @typedef {function(string):string} IconUrlFunction
 * @api
 */ /**
 * Function that returns a url unchanged.
 * @param {string} href Input url.
 * @return {string} Output url.
 */ function $1140dfbeee585f32$var$defaultIconUrlFunction(href) {
    return href;
}
/**
 * @typedef {Object} Options
 * @property {boolean} [extractStyles=true] Extract styles from the KML.
 * @property {boolean} [showPointNames=true] Show names as labels for placemarks which contain points.
 * @property {Array<Style>} [defaultStyle] Default style. The
 * default default style is the same as Google Earth.
 * @property {boolean} [writeStyles=true] Write styles into KML.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * @property {IconUrlFunction} [iconUrlFunction] Function that takes a url string and returns a url string.
 * Might be used to change an icon path or to substitute a data url obtained from a KMZ array buffer.
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the KML format.
 *
 * {@link module:ol/format/KML~KML#readFeature} will read the first feature from
 * a KML source.
 *
 * MultiGeometries are converted into GeometryCollections if they are a mix of
 * geometry types, and into MultiPoint/MultiLineString/MultiPolygon if they are
 * all of the same type.
 *
 * @api
 */ class $1140dfbeee585f32$var$KML extends (0, $ce16c3ce3167dc37$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        if (!$1140dfbeee585f32$var$DEFAULT_STYLE_ARRAY) $1140dfbeee585f32$var$createStyleDefaults();
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $dpRHA.get)("EPSG:4326");
        /**
     * @private
     * @type {Array<Style>}
     */ this.defaultStyle_ = options.defaultStyle ? options.defaultStyle : $1140dfbeee585f32$var$DEFAULT_STYLE_ARRAY;
        /**
     * @private
     * @type {boolean}
     */ this.extractStyles_ = options.extractStyles !== undefined ? options.extractStyles : true;
        /**
     * @type {boolean}
     */ this.writeStyles_ = options.writeStyles !== undefined ? options.writeStyles : true;
        /**
     * @private
     * @type {!Object<string, (Array<Style>|string)>}
     */ this.sharedStyles_ = {};
        /**
     * @private
     * @type {boolean}
     */ this.showPointNames_ = options.showPointNames !== undefined ? options.showPointNames : true;
        /**
     * @type {null|string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : "anonymous";
        /**
     * @type {IconUrlFunction}
     */ this.iconUrlFunction_ = options.iconUrlFunction ? options.iconUrlFunction : $1140dfbeee585f32$var$defaultIconUrlFunction;
        this.supportedMediaTypes = [
            "application/vnd.google-earth.kml+xml"
        ];
    }
    /**
   * @param {Node} node Node.
   * @param {Array<*>} objectStack Object stack.
   * @private
   * @return {Array<Feature>|undefined} Features.
   */ readDocumentOrFolder_(node, objectStack) {
        // FIXME use scope somehow
        const parsersNS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
            "Document": (0, $a4f89edd2ef65182$export$b2d5eb949eb55a2a)(this.readDocumentOrFolder_, this),
            "Folder": (0, $a4f89edd2ef65182$export$b2d5eb949eb55a2a)(this.readDocumentOrFolder_, this),
            "Placemark": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)(this.readPlacemark_, this),
            "Style": this.readSharedStyle_.bind(this),
            "StyleMap": this.readSharedStyleMap_.bind(this)
        });
        /** @type {Array<Feature>} */ // @ts-ignore
        const features = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)([], parsersNS, node, objectStack, this);
        if (features) return features;
        return undefined;
    }
    /**
   * @param {Element} node Node.
   * @param {Array<*>} objectStack Object stack.
   * @private
   * @return {Feature|undefined} Feature.
   */ readPlacemark_(node, objectStack) {
        const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({
            "geometry": null
        }, $1140dfbeee585f32$var$PLACEMARK_PARSERS, node, objectStack, this);
        if (!object) return undefined;
        const feature = new (0, $dIG9p.default)();
        const id = node.getAttribute("id");
        if (id !== null) feature.setId(id);
        const options = /** @type {import("./Feature.js").ReadOptions} */ objectStack[0];
        const geometry = object["geometry"];
        if (geometry) (0, $kgouC.transformGeometryWithOptions)(geometry, false, options);
        feature.setGeometry(geometry);
        delete object["geometry"];
        if (this.extractStyles_) {
            const style = object["Style"];
            const styleUrl = object["styleUrl"];
            const styleFunction = $1140dfbeee585f32$var$createFeatureStyleFunction(style, styleUrl, this.defaultStyle_, this.sharedStyles_, this.showPointNames_);
            feature.setStyle(styleFunction);
        }
        delete object["Style"];
        // we do not remove the styleUrl property from the object, so it
        // gets stored on feature when setProperties is called
        feature.setProperties(object, true);
        return feature;
    }
    /**
   * @param {Element} node Node.
   * @param {Array<*>} objectStack Object stack.
   * @private
   */ readSharedStyle_(node, objectStack) {
        const id = node.getAttribute("id");
        if (id !== null) {
            const style = $1140dfbeee585f32$var$readStyle.call(this, node, objectStack);
            if (style) {
                let styleUri;
                let baseURI = node.baseURI;
                if (!baseURI || baseURI == "about:blank") baseURI = window.location.href;
                if (baseURI) {
                    const url = new URL("#" + id, baseURI);
                    styleUri = url.href;
                } else styleUri = "#" + id;
                this.sharedStyles_[styleUri] = style;
            }
        }
    }
    /**
   * @param {Element} node Node.
   * @param {Array<*>} objectStack Object stack.
   * @private
   */ readSharedStyleMap_(node, objectStack) {
        const id = node.getAttribute("id");
        if (id === null) return;
        const styleMapValue = $1140dfbeee585f32$var$readStyleMapValue.call(this, node, objectStack);
        if (!styleMapValue) return;
        let styleUri;
        let baseURI = node.baseURI;
        if (!baseURI || baseURI == "about:blank") baseURI = window.location.href;
        if (baseURI) {
            const url = new URL("#" + id, baseURI);
            styleUri = url.href;
        } else styleUri = "#" + id;
        this.sharedStyles_[styleUri] = styleMapValue;
    }
    /**
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {import("../Feature.js").default} Feature.
   */ readFeatureFromNode(node, options) {
        if (!$1140dfbeee585f32$var$NAMESPACE_URIS.includes(node.namespaceURI)) return null;
        const feature = this.readPlacemark_(node, [
            this.getReadOptions(node, options)
        ]);
        if (feature) return feature;
        return null;
    }
    /**
   * @protected
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {Array<import("../Feature.js").default>} Features.
   */ readFeaturesFromNode(node, options) {
        if (!$1140dfbeee585f32$var$NAMESPACE_URIS.includes(node.namespaceURI)) return [];
        let features;
        const localName = node.localName;
        if (localName == "Document" || localName == "Folder") {
            features = this.readDocumentOrFolder_(node, [
                this.getReadOptions(node, options)
            ]);
            if (features) return features;
            return [];
        }
        if (localName == "Placemark") {
            const feature = this.readPlacemark_(node, [
                this.getReadOptions(node, options)
            ]);
            if (feature) return [
                feature
            ];
            return [];
        }
        if (localName == "kml") {
            features = [];
            for(let n = node.firstElementChild; n; n = n.nextElementSibling){
                const fs = this.readFeaturesFromNode(n, options);
                if (fs) (0, $fVVyM.extend)(features, fs);
            }
            return features;
        }
        return [];
    }
    /**
   * Read the name of the KML.
   *
   * @param {Document|Element|string} source Source.
   * @return {string|undefined} Name.
   * @api
   */ readName(source) {
        if (!source) return undefined;
        if (typeof source === "string") {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            return this.readNameFromDocument(doc);
        }
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readNameFromDocument(/** @type {Document} */ source);
        return this.readNameFromNode(/** @type {Element} */ source);
    }
    /**
   * @param {Document} doc Document.
   * @return {string|undefined} Name.
   */ readNameFromDocument(doc) {
        for(let n = /** @type {Node} */ doc.firstChild; n; n = n.nextSibling)if (n.nodeType == Node.ELEMENT_NODE) {
            const name = this.readNameFromNode(/** @type {Element} */ n);
            if (name) return name;
        }
        return undefined;
    }
    /**
   * @param {Element} node Node.
   * @return {string|undefined} Name.
   */ readNameFromNode(node) {
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && n.localName == "name") return (0, $d5e0fde316cac971$export$dda73877cb166cd3)(n);
        }
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            const localName = n.localName;
            if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && (localName == "Document" || localName == "Folder" || localName == "Placemark" || localName == "kml")) {
                const name = this.readNameFromNode(n);
                if (name) return name;
            }
        }
        return undefined;
    }
    /**
   * Read the network links of the KML.
   *
   * @param {Document|Element|string} source Source.
   * @return {Array<Object>} Network links.
   * @api
   */ readNetworkLinks(source) {
        const networkLinks = [];
        if (typeof source === "string") {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            (0, $fVVyM.extend)(networkLinks, this.readNetworkLinksFromDocument(doc));
        } else if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) (0, $fVVyM.extend)(networkLinks, this.readNetworkLinksFromDocument(/** @type {Document} */ source));
        else (0, $fVVyM.extend)(networkLinks, this.readNetworkLinksFromNode(/** @type {Element} */ source));
        return networkLinks;
    }
    /**
   * @param {Document} doc Document.
   * @return {Array<Object>} Network links.
   */ readNetworkLinksFromDocument(doc) {
        const networkLinks = [];
        for(let n = /** @type {Node} */ doc.firstChild; n; n = n.nextSibling)if (n.nodeType == Node.ELEMENT_NODE) (0, $fVVyM.extend)(networkLinks, this.readNetworkLinksFromNode(/** @type {Element} */ n));
        return networkLinks;
    }
    /**
   * @param {Element} node Node.
   * @return {Array<Object>} Network links.
   */ readNetworkLinksFromNode(node) {
        const networkLinks = [];
        for(let n = node.firstElementChild; n; n = n.nextElementSibling)if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && n.localName == "NetworkLink") {
            const obj = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$NETWORK_LINK_PARSERS, n, []);
            networkLinks.push(obj);
        }
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            const localName = n.localName;
            if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && (localName == "Document" || localName == "Folder" || localName == "kml")) (0, $fVVyM.extend)(networkLinks, this.readNetworkLinksFromNode(n));
        }
        return networkLinks;
    }
    /**
   * Read the regions of the KML.
   *
   * @param {Document|Element|string} source Source.
   * @return {Array<Object>} Regions.
   * @api
   */ readRegion(source) {
        const regions = [];
        if (typeof source === "string") {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            (0, $fVVyM.extend)(regions, this.readRegionFromDocument(doc));
        } else if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) (0, $fVVyM.extend)(regions, this.readRegionFromDocument(/** @type {Document} */ source));
        else (0, $fVVyM.extend)(regions, this.readRegionFromNode(/** @type {Element} */ source));
        return regions;
    }
    /**
   * @param {Document} doc Document.
   * @return {Array<Object>} Region.
   */ readRegionFromDocument(doc) {
        const regions = [];
        for(let n = /** @type {Node} */ doc.firstChild; n; n = n.nextSibling)if (n.nodeType == Node.ELEMENT_NODE) (0, $fVVyM.extend)(regions, this.readRegionFromNode(/** @type {Element} */ n));
        return regions;
    }
    /**
   * @param {Element} node Node.
   * @return {Array<Object>} Region.
   * @api
   */ readRegionFromNode(node) {
        const regions = [];
        for(let n = node.firstElementChild; n; n = n.nextElementSibling)if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && n.localName == "Region") {
            const obj = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$REGION_PARSERS, n, []);
            regions.push(obj);
        }
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            const localName = n.localName;
            if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && (localName == "Document" || localName == "Folder" || localName == "kml")) (0, $fVVyM.extend)(regions, this.readRegionFromNode(n));
        }
        return regions;
    }
    /**
   * @typedef {Object} KMLCamera Specifies the observer's viewpoint and associated view parameters.
   * @property {number} [Latitude] Latitude of the camera.
   * @property {number} [Longitude] Longitude of the camera.
   * @property {number} [Altitude] Altitude of the camera.
   * @property {string} [AltitudeMode] Floor-related altitude mode.
   * @property {number} [Heading] Horizontal camera rotation.
   * @property {number} [Tilt] Lateral camera rotation.
   * @property {number} [Roll] Vertical camera rotation.
   */ /**
   * Read the cameras of the KML.
   *
   * @param {Document|Element|string} source Source.
   * @return {Array<KMLCamera>} Cameras.
   * @api
   */ readCamera(source) {
        const cameras = [];
        if (typeof source === "string") {
            const doc = (0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source);
            (0, $fVVyM.extend)(cameras, this.readCameraFromDocument(doc));
        } else if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) (0, $fVVyM.extend)(cameras, this.readCameraFromDocument(/** @type {Document} */ source));
        else (0, $fVVyM.extend)(cameras, this.readCameraFromNode(/** @type {Element} */ source));
        return cameras;
    }
    /**
   * @param {Document} doc Document.
   * @return {Array<KMLCamera>} Cameras.
   */ readCameraFromDocument(doc) {
        const cameras = [];
        for(let n = /** @type {Node} */ doc.firstChild; n; n = n.nextSibling)if (n.nodeType === Node.ELEMENT_NODE) (0, $fVVyM.extend)(cameras, this.readCameraFromNode(/** @type {Element} */ n));
        return cameras;
    }
    /**
   * @param {Element} node Node.
   * @return {Array<KMLCamera>} Cameras.
   * @api
   */ readCameraFromNode(node) {
        const cameras = [];
        for(let n = node.firstElementChild; n; n = n.nextElementSibling)if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && n.localName === "Camera") {
            const obj = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$CAMERA_PARSERS, n, []);
            cameras.push(obj);
        }
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            const localName = n.localName;
            if ($1140dfbeee585f32$var$NAMESPACE_URIS.includes(n.namespaceURI) && (localName === "Document" || localName === "Folder" || localName === "Placemark" || localName === "kml")) (0, $fVVyM.extend)(cameras, this.readCameraFromNode(n));
        }
        return cameras;
    }
    /**
   * Encode an array of features in the KML format as an XML node. GeometryCollections,
   * MultiPoints, MultiLineStrings, and MultiPolygons are output as MultiGeometries.
   *
   * @param {Array<Feature>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Options.
   * @return {Node} Node.
   * @api
   */ writeFeaturesNode(features, options) {
        options = this.adaptOptions(options);
        const kml = (0, $a4f89edd2ef65182$export$7094a064528c7fee)($1140dfbeee585f32$var$NAMESPACE_URIS[4], "kml");
        const xmlnsUri = "http://www.w3.org/2000/xmlns/";
        kml.setAttributeNS(xmlnsUri, "xmlns:gx", $1140dfbeee585f32$var$GX_NAMESPACE_URIS[0]);
        kml.setAttributeNS(xmlnsUri, "xmlns:xsi", (0, $a4f89edd2ef65182$export$be284679de3fbea8));
        kml.setAttributeNS((0, $a4f89edd2ef65182$export$be284679de3fbea8), "xsi:schemaLocation", $1140dfbeee585f32$var$SCHEMA_LOCATION);
        const /** @type {import("../xml.js").NodeStackItem} */ context = {
            node: kml
        };
        /** @type {!Object<string, (Array<Feature>|Feature|undefined)>} */ const properties = {};
        if (features.length > 1) properties["Document"] = features;
        else if (features.length == 1) properties["Placemark"] = features[0];
        const orderedKeys = $1140dfbeee585f32$var$KML_SEQUENCE[kml.namespaceURI];
        const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
        (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$KML_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, [
            options
        ], orderedKeys, this);
        return kml;
    }
}
/**
 * @param {Style|undefined} foundStyle Style.
 * @param {string} name Name.
 * @return {Style} style Style.
 */ function $1140dfbeee585f32$var$createNameStyleFunction(foundStyle, name) {
    const textOffset = [
        0,
        0
    ];
    /** @type {CanvasTextAlign} */ let textAlign = "start";
    const imageStyle = foundStyle.getImage();
    if (imageStyle) {
        const imageSize = imageStyle.getSize();
        if (imageSize && imageSize.length == 2) {
            const imageScale = imageStyle.getScaleArray();
            const anchor = imageStyle.getAnchor();
            // Offset the label to be centered to the right of the icon,
            // if there is one.
            textOffset[0] = imageScale[0] * (imageSize[0] - anchor[0]);
            textOffset[1] = imageScale[1] * (imageSize[1] / 2 - anchor[1]);
            textAlign = "left";
        }
    }
    let textStyle = foundStyle.getText();
    if (textStyle) {
        // clone the text style, customizing it with name, alignments and offset.
        // Note that kml does not support many text options that OpenLayers does (rotation, textBaseline).
        textStyle = textStyle.clone();
        textStyle.setFont(textStyle.getFont() || $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE.getFont());
        textStyle.setScale(textStyle.getScale() || $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE.getScale());
        textStyle.setFill(textStyle.getFill() || $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE.getFill());
        textStyle.setStroke(textStyle.getStroke() || $1140dfbeee585f32$var$DEFAULT_TEXT_STROKE_STYLE);
    } else textStyle = $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE.clone();
    textStyle.setText(name);
    textStyle.setOffsetX(textOffset[0]);
    textStyle.setOffsetY(textOffset[1]);
    textStyle.setTextAlign(textAlign);
    const nameStyle = new (0, $c3RIb.default)({
        image: imageStyle,
        text: textStyle
    });
    return nameStyle;
}
/**
 * @param {Array<Style>|undefined} style Style.
 * @param {string} styleUrl Style URL.
 * @param {Array<Style>} defaultStyle Default style.
 * @param {!Object<string, (Array<Style>|string)>} sharedStyles Shared styles.
 * @param {boolean|undefined} showPointNames true to show names for point placemarks.
 * @return {import("../style/Style.js").StyleFunction} Feature style function.
 */ function $1140dfbeee585f32$var$createFeatureStyleFunction(style, styleUrl, defaultStyle, sharedStyles, showPointNames) {
    return(/**
     * @param {Feature} feature feature.
     * @param {number} resolution Resolution.
     * @return {Array<Style>|Style} Style.
     */ function(feature, resolution) {
        let drawName = showPointNames;
        let name = "";
        let multiGeometryPoints = [];
        if (drawName) {
            const geometry = feature.getGeometry();
            if (geometry) {
                if (geometry instanceof (0, $1eatv.default)) {
                    multiGeometryPoints = geometry.getGeometriesArrayRecursive().filter(function(geometry) {
                        const type = geometry.getType();
                        return type === "Point" || type === "MultiPoint";
                    });
                    drawName = multiGeometryPoints.length > 0;
                } else {
                    const type = geometry.getType();
                    drawName = type === "Point" || type === "MultiPoint";
                }
            }
        }
        if (drawName) {
            name = /** @type {string} */ feature.get("name");
            drawName = drawName && !!name;
            // convert any html character codes
            if (drawName && /&[^&]+;/.test(name)) {
                if (!$1140dfbeee585f32$var$TEXTAREA) $1140dfbeee585f32$var$TEXTAREA = document.createElement("textarea");
                $1140dfbeee585f32$var$TEXTAREA.innerHTML = name;
                name = $1140dfbeee585f32$var$TEXTAREA.value;
            }
        }
        let featureStyle = defaultStyle;
        if (style) featureStyle = style;
        else if (styleUrl) featureStyle = $1140dfbeee585f32$var$findStyle(styleUrl, defaultStyle, sharedStyles);
        if (drawName) {
            const nameStyle = $1140dfbeee585f32$var$createNameStyleFunction(featureStyle[0], name);
            if (multiGeometryPoints.length > 0) {
                // in multigeometries restrict the name style to points and create a
                // style without image or text for geometries requiring fill or stroke
                // including any polygon specific style if there is one
                nameStyle.setGeometry(new (0, $1eatv.default)(multiGeometryPoints));
                const baseStyle = new (0, $c3RIb.default)({
                    geometry: featureStyle[0].getGeometry(),
                    image: null,
                    fill: featureStyle[0].getFill(),
                    stroke: featureStyle[0].getStroke(),
                    text: null
                });
                return [
                    nameStyle,
                    baseStyle
                ].concat(featureStyle.slice(1));
            }
            return nameStyle;
        }
        return featureStyle;
    });
}
/**
 * @param {Array<Style>|string|undefined} styleValue Style value.
 * @param {Array<Style>} defaultStyle Default style.
 * @param {!Object<string, (Array<Style>|string)>} sharedStyles
 * Shared styles.
 * @return {Array<Style>} Style.
 */ function $1140dfbeee585f32$var$findStyle(styleValue, defaultStyle, sharedStyles) {
    if (Array.isArray(styleValue)) return styleValue;
    if (typeof styleValue === "string") return $1140dfbeee585f32$var$findStyle(sharedStyles[styleValue], defaultStyle, sharedStyles);
    return defaultStyle;
}
/**
 * @param {Node} node Node.
 * @return {import("../color.js").Color|undefined} Color.
 */ function $1140dfbeee585f32$var$readColor(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    // The KML specification states that colors should not include a leading `#`
    // but we tolerate them.
    const m = /^\s*#?\s*([0-9A-Fa-f]{8})\s*$/.exec(s);
    if (m) {
        const hexColor = m[1];
        return [
            parseInt(hexColor.substr(6, 2), 16),
            parseInt(hexColor.substr(4, 2), 16),
            parseInt(hexColor.substr(2, 2), 16),
            parseInt(hexColor.substr(0, 2), 16) / 255
        ];
    }
    return undefined;
}
function $1140dfbeee585f32$export$b231062f8c36cd1(node) {
    let s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    const flatCoordinates = [];
    // The KML specification states that coordinate tuples should not include
    // spaces, but we tolerate them.
    s = s.replace(/\s*,\s*/g, ",");
    const re = /^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?),([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s+|,|$)(?:([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s+|$))?\s*/i;
    let m;
    while(m = re.exec(s)){
        const x = parseFloat(m[1]);
        const y = parseFloat(m[2]);
        const z = m[3] ? parseFloat(m[3]) : 0;
        flatCoordinates.push(x, y, z);
        s = s.substr(m[0].length);
    }
    if (s !== "") return undefined;
    return flatCoordinates;
}
/**
 * @param {Node} node Node.
 * @return {string} URI.
 */ function $1140dfbeee585f32$var$readURI(node) {
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false).trim();
    let baseURI = node.baseURI;
    if (!baseURI || baseURI == "about:blank") baseURI = window.location.href;
    if (baseURI) {
        const url = new URL(s, baseURI);
        return url.href;
    }
    return s;
}
/**
 * @param {Node} node Node.
 * @return {string} URI.
 */ function $1140dfbeee585f32$var$readStyleURL(node) {
    // KML files in the wild occasionally forget the leading
    // `#` on styleUrlsdefined in the same document.
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false).trim().replace(/^(?!.*#)/, "#");
    let baseURI = node.baseURI;
    if (!baseURI || baseURI == "about:blank") baseURI = window.location.href;
    if (baseURI) {
        const url = new URL(s, baseURI);
        return url.href;
    }
    return s;
}
/**
 * @param {Element} node Node.
 * @return {Vec2} Vec2.
 */ function $1140dfbeee585f32$var$readVec2(node) {
    const xunits = node.getAttribute("xunits");
    const yunits = node.getAttribute("yunits");
    /** @type {import('../style/Icon.js').IconOrigin} */ let origin;
    if (xunits !== "insetPixels") {
        if (yunits !== "insetPixels") origin = "bottom-left";
        else origin = "top-left";
    } else if (yunits !== "insetPixels") origin = "bottom-right";
    else origin = "top-right";
    return {
        x: parseFloat(node.getAttribute("x")),
        xunits: $1140dfbeee585f32$var$ICON_ANCHOR_UNITS_MAP[xunits],
        y: parseFloat(node.getAttribute("y")),
        yunits: $1140dfbeee585f32$var$ICON_ANCHOR_UNITS_MAP[yunits],
        origin: origin
    };
}
/**
 * @param {Node} node Node.
 * @return {number|undefined} Scale.
 */ function $1140dfbeee585f32$var$readScale(node) {
    return (0, $d5e0fde316cac971$export$5be9c99d34ad295b)(node);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$STYLE_MAP_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "Pair": $1140dfbeee585f32$var$pairDataParser
});
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<Style>|string|undefined} StyleMap.
 */ function $1140dfbeee585f32$var$readStyleMapValue(node, objectStack) {
    return (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(undefined, $1140dfbeee585f32$var$STYLE_MAP_PARSERS, node, objectStack, this);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_STYLE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "Icon": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readIcon),
    "color": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readColor),
    "heading": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "hotSpot": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readVec2),
    "scale": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readScale)
});
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$iconStyleParser(node, objectStack) {
    // FIXME refreshMode
    // FIXME refreshInterval
    // FIXME viewRefreshTime
    // FIXME viewBoundScale
    // FIXME viewFormat
    // FIXME httpQuery
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$ICON_STYLE_PARSERS, node, objectStack);
    if (!object) return;
    const styleObject = /** @type {Object} */ objectStack[objectStack.length - 1];
    const IconObject = "Icon" in object ? object["Icon"] : {};
    const drawIcon = !("Icon" in object) || Object.keys(IconObject).length > 0;
    let src;
    const href = /** @type {string|undefined} */ IconObject["href"];
    if (href) src = href;
    else if (drawIcon) src = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SRC;
    let anchor, anchorXUnits, anchorYUnits;
    /** @type {import('../style/Icon.js').IconOrigin|undefined} */ let anchorOrigin = "bottom-left";
    const hotSpot = /** @type {Vec2|undefined} */ object["hotSpot"];
    if (hotSpot) {
        anchor = [
            hotSpot.x,
            hotSpot.y
        ];
        anchorXUnits = hotSpot.xunits;
        anchorYUnits = hotSpot.yunits;
        anchorOrigin = hotSpot.origin;
    } else if (/^https?:\/\/maps\.(?:google|gstatic)\.com\//.test(src)) {
        // Google hotspots from https://kml4earth.appspot.com/icons.html#notes
        if (src.includes("pushpin")) {
            anchor = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR;
            anchorXUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
            anchorYUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
        } else if (src.includes("arrow-reverse")) {
            anchor = [
                54,
                42
            ];
            anchorXUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
            anchorYUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
        } else if (src.includes("paddle")) {
            anchor = [
                32,
                1
            ];
            anchorXUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
            anchorYUnits = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
        }
    }
    let offset;
    const x = /** @type {number|undefined} */ IconObject["x"];
    const y = /** @type {number|undefined} */ IconObject["y"];
    if (x !== undefined && y !== undefined) offset = [
        x,
        y
    ];
    let size;
    const w = /** @type {number|undefined} */ IconObject["w"];
    const h = /** @type {number|undefined} */ IconObject["h"];
    if (w !== undefined && h !== undefined) size = [
        w,
        h
    ];
    let rotation;
    const heading = /** @type {number} */ object["heading"];
    if (heading !== undefined) rotation = (0, $9byFX.toRadians)(heading);
    const scale = /** @type {number|undefined} */ object["scale"];
    const color = /** @type {Array<number>|undefined} */ object["color"];
    if (drawIcon) {
        if (src == $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SRC) size = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE;
        const imageStyle = new (0, $bmHVE.default)({
            anchor: anchor,
            anchorOrigin: anchorOrigin,
            anchorXUnits: anchorXUnits,
            anchorYUnits: anchorYUnits,
            crossOrigin: this.crossOrigin_,
            offset: offset,
            offsetOrigin: "bottom-left",
            rotation: rotation,
            scale: scale,
            size: size,
            src: this.iconUrlFunction_(src),
            color: color
        });
        const imageScale = imageStyle.getScaleArray()[0];
        const imageSize = imageStyle.getSize();
        if (imageSize === null) {
            const imageState = imageStyle.getImageState();
            if (imageState === (0, $aSvtr.default).IDLE || imageState === (0, $aSvtr.default).LOADING) {
                const listener = function() {
                    const imageState = imageStyle.getImageState();
                    if (!(imageState === (0, $aSvtr.default).IDLE || imageState === (0, $aSvtr.default).LOADING)) {
                        const imageSize = imageStyle.getSize();
                        if (imageSize && imageSize.length == 2) {
                            const resizeScale = $1140dfbeee585f32$var$scaleForSize(imageSize);
                            imageStyle.setScale(imageScale * resizeScale);
                        }
                        imageStyle.unlistenImageChange(listener);
                    }
                };
                imageStyle.listenImageChange(listener);
                if (imageState === (0, $aSvtr.default).IDLE) imageStyle.load();
            }
        } else if (imageSize.length == 2) {
            const resizeScale = $1140dfbeee585f32$var$scaleForSize(imageSize);
            imageStyle.setScale(imageScale * resizeScale);
        }
        styleObject["imageStyle"] = imageStyle;
    } else // handle the case when we explicitly want to draw no icon.
    styleObject["imageStyle"] = $1140dfbeee585f32$var$DEFAULT_NO_IMAGE_STYLE;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LABEL_STYLE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "color": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readColor),
    "scale": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readScale)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$labelStyleParser(node, objectStack) {
    // FIXME colorMode
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$LABEL_STYLE_PARSERS, node, objectStack);
    if (!object) return;
    const styleObject = objectStack[objectStack.length - 1];
    const textStyle = new (0, $cJntk.default)({
        fill: new (0, $inIMS.default)({
            color: /** @type {import("../color.js").Color} */ "color" in object ? object["color"] : $1140dfbeee585f32$var$DEFAULT_COLOR
        }),
        scale: /** @type {number|undefined} */ object["scale"]
    });
    styleObject["textStyle"] = textStyle;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LINE_STYLE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "color": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readColor),
    "width": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$lineStyleParser(node, objectStack) {
    // FIXME colorMode
    // FIXME gx:outerColor
    // FIXME gx:outerWidth
    // FIXME gx:physicalWidth
    // FIXME gx:labelVisibility
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$LINE_STYLE_PARSERS, node, objectStack);
    if (!object) return;
    const styleObject = objectStack[objectStack.length - 1];
    const strokeStyle = new (0, $lrKvI.default)({
        color: /** @type {import("../color.js").Color} */ "color" in object ? object["color"] : $1140dfbeee585f32$var$DEFAULT_COLOR,
        width: /** @type {number} */ "width" in object ? object["width"] : 1
    });
    styleObject["strokeStyle"] = strokeStyle;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$POLY_STYLE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "color": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readColor),
    "fill": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5)),
    "outline": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$polyStyleParser(node, objectStack) {
    // FIXME colorMode
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$POLY_STYLE_PARSERS, node, objectStack);
    if (!object) return;
    const styleObject = objectStack[objectStack.length - 1];
    const fillStyle = new (0, $inIMS.default)({
        color: /** @type {import("../color.js").Color} */ "color" in object ? object["color"] : $1140dfbeee585f32$var$DEFAULT_COLOR
    });
    styleObject["fillStyle"] = fillStyle;
    const fill = /** @type {boolean|undefined} */ object["fill"];
    if (fill !== undefined) styleObject["fill"] = fill;
    const outline = /** @type {boolean|undefined} */ object["outline"];
    if (outline !== undefined) styleObject["outline"] = outline;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$FLAT_LINEAR_RING_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "coordinates": (0, $a4f89edd2ef65182$export$b1b80676c57c5713)($1140dfbeee585f32$export$b231062f8c36cd1)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<number>} LinearRing flat coordinates.
 */ function $1140dfbeee585f32$var$readFlatLinearRing(node, objectStack) {
    return (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(null, $1140dfbeee585f32$var$FLAT_LINEAR_RING_PARSERS, node, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$gxCoordParser(node, objectStack) {
    const gxTrackObject = /** @type {GxTrackObject} */ objectStack[objectStack.length - 1];
    const coordinates = gxTrackObject.coordinates;
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    const re = /^\s*([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s*$/i;
    const m = re.exec(s);
    if (m) {
        const x = parseFloat(m[1]);
        const y = parseFloat(m[2]);
        const z = parseFloat(m[3]);
        coordinates.push([
            x,
            y,
            z
        ]);
    } else coordinates.push([]);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$GX_MULTITRACK_GEOMETRY_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, {
    "Track": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readGxTrack)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {MultiLineString|undefined} MultiLineString.
 */ function $1140dfbeee585f32$var$readGxMultiTrack(node, objectStack) {
    const lineStrings = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)([], $1140dfbeee585f32$var$GX_MULTITRACK_GEOMETRY_PARSERS, node, objectStack);
    if (!lineStrings) return undefined;
    return new (0, $fw94T.default)(lineStrings);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$GX_TRACK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "when": $1140dfbeee585f32$var$whenParser
}, (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, {
    "coord": $1140dfbeee585f32$var$gxCoordParser
}));
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {LineString|undefined} LineString.
 */ function $1140dfbeee585f32$var$readGxTrack(node, objectStack) {
    const gxTrackObject = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(/** @type {GxTrackObject} */ {
        coordinates: [],
        whens: []
    }, $1140dfbeee585f32$var$GX_TRACK_PARSERS, node, objectStack);
    if (!gxTrackObject) return undefined;
    const flatCoordinates = [];
    const coordinates = gxTrackObject.coordinates;
    const whens = gxTrackObject.whens;
    for(let i = 0, ii = Math.min(coordinates.length, whens.length); i < ii; ++i)if (coordinates[i].length == 3) flatCoordinates.push(coordinates[i][0], coordinates[i][1], coordinates[i][2], whens[i]);
    return new (0, $3xcD3.default)(flatCoordinates, "XYZM");
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "href": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readURI)
}, (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, {
    "x": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "y": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "w": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "h": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b))
}));
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object} Icon object.
 */ function $1140dfbeee585f32$var$readIcon(node, objectStack) {
    const iconObject = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$ICON_PARSERS, node, objectStack);
    if (iconObject) return iconObject;
    return null;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$GEOMETRY_FLAT_COORDINATES_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "coordinates": (0, $a4f89edd2ef65182$export$b1b80676c57c5713)($1140dfbeee585f32$export$b231062f8c36cd1)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<number>} Flat coordinates.
 */ function $1140dfbeee585f32$var$readFlatCoordinatesFromNode(node, objectStack) {
    return (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(null, $1140dfbeee585f32$var$GEOMETRY_FLAT_COORDINATES_PARSERS, node, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$EXTRUDE_AND_ALTITUDE_MODE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "extrude": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5)),
    "tessellate": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$f9a84177eae95ed5)),
    "altitudeMode": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {LineString|undefined} LineString.
 */ function $1140dfbeee585f32$var$readLineString(node, objectStack) {
    const properties = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    const flatCoordinates = $1140dfbeee585f32$var$readFlatCoordinatesFromNode(node, objectStack);
    if (flatCoordinates) {
        const lineString = new (0, $3xcD3.default)(flatCoordinates, "XYZ");
        lineString.setProperties(properties, true);
        return lineString;
    }
    return undefined;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Polygon|undefined} Polygon.
 */ function $1140dfbeee585f32$var$readLinearRing(node, objectStack) {
    const properties = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    const flatCoordinates = $1140dfbeee585f32$var$readFlatCoordinatesFromNode(node, objectStack);
    if (flatCoordinates) {
        const polygon = new (0, $5ydre.default)(flatCoordinates, "XYZ", [
            flatCoordinates.length
        ]);
        polygon.setProperties(properties, true);
        return polygon;
    }
    return undefined;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$MULTI_GEOMETRY_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "LineString": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readLineString),
    "LinearRing": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readLinearRing),
    "MultiGeometry": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readMultiGeometry),
    "Point": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readPoint),
    "Polygon": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readPolygon)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $1140dfbeee585f32$var$readMultiGeometry(node, objectStack) {
    const geometries = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)([], $1140dfbeee585f32$var$MULTI_GEOMETRY_PARSERS, node, objectStack);
    if (!geometries) return null;
    if (geometries.length === 0) return new (0, $1eatv.default)(geometries);
    let multiGeometry;
    let homogeneous = true;
    const type = geometries[0].getType();
    let geometry;
    for(let i = 1, ii = geometries.length; i < ii; ++i){
        geometry = geometries[i];
        if (geometry.getType() != type) {
            homogeneous = false;
            break;
        }
    }
    if (homogeneous) {
        let layout;
        let flatCoordinates;
        if (type == "Point") {
            const point = geometries[0];
            layout = point.getLayout();
            flatCoordinates = point.getFlatCoordinates();
            for(let i = 1, ii = geometries.length; i < ii; ++i){
                geometry = geometries[i];
                (0, $fVVyM.extend)(flatCoordinates, geometry.getFlatCoordinates());
            }
            multiGeometry = new (0, $jKs1i.default)(flatCoordinates, layout);
            $1140dfbeee585f32$var$setCommonGeometryProperties(multiGeometry, geometries);
        } else if (type == "LineString") {
            multiGeometry = new (0, $fw94T.default)(geometries);
            $1140dfbeee585f32$var$setCommonGeometryProperties(multiGeometry, geometries);
        } else if (type == "Polygon") {
            multiGeometry = new (0, $le5ya.default)(geometries);
            $1140dfbeee585f32$var$setCommonGeometryProperties(multiGeometry, geometries);
        } else if (type == "GeometryCollection") multiGeometry = new (0, $1eatv.default)(geometries);
        else throw new Error("Unknown geometry type found");
    } else multiGeometry = new (0, $1eatv.default)(geometries);
    return /** @type {import("../geom/Geometry.js").default} */ multiGeometry;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Point|undefined} Point.
 */ function $1140dfbeee585f32$var$readPoint(node, objectStack) {
    const properties = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    const flatCoordinates = $1140dfbeee585f32$var$readFlatCoordinatesFromNode(node, objectStack);
    if (flatCoordinates) {
        const point = new (0, $9vPkX.default)(flatCoordinates, "XYZ");
        point.setProperties(properties, true);
        return point;
    }
    return undefined;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$FLAT_LINEAR_RINGS_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "innerBoundaryIs": $1140dfbeee585f32$var$innerBoundaryIsParser,
    "outerBoundaryIs": $1140dfbeee585f32$var$outerBoundaryIsParser
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Polygon|undefined} Polygon.
 */ function $1140dfbeee585f32$var$readPolygon(node, objectStack) {
    const properties = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(/** @type {Object<string,*>} */ {}, $1140dfbeee585f32$var$EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    const flatLinearRings = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)([
        null
    ], $1140dfbeee585f32$var$FLAT_LINEAR_RINGS_PARSERS, node, objectStack);
    if (flatLinearRings && flatLinearRings[0]) {
        const flatCoordinates = flatLinearRings[0];
        const ends = [
            flatCoordinates.length
        ];
        for(let i = 1, ii = flatLinearRings.length; i < ii; ++i){
            (0, $fVVyM.extend)(flatCoordinates, flatLinearRings[i]);
            ends.push(flatCoordinates.length);
        }
        const polygon = new (0, $5ydre.default)(flatCoordinates, "XYZ", ends);
        polygon.setProperties(properties, true);
        return polygon;
    }
    return undefined;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$STYLE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "IconStyle": $1140dfbeee585f32$var$iconStyleParser,
    "LabelStyle": $1140dfbeee585f32$var$labelStyleParser,
    "LineStyle": $1140dfbeee585f32$var$lineStyleParser,
    "PolyStyle": $1140dfbeee585f32$var$polyStyleParser
});
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<Style>} Style.
 */ function $1140dfbeee585f32$var$readStyle(node, objectStack) {
    const styleObject = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$STYLE_PARSERS, node, objectStack, this);
    if (!styleObject) return null;
    let fillStyle = /** @type {Fill} */ "fillStyle" in styleObject ? styleObject["fillStyle"] : $1140dfbeee585f32$var$DEFAULT_FILL_STYLE;
    const fill = /** @type {boolean|undefined} */ styleObject["fill"];
    if (fill !== undefined && !fill) fillStyle = null;
    let imageStyle;
    if ("imageStyle" in styleObject) {
        if (styleObject["imageStyle"] != $1140dfbeee585f32$var$DEFAULT_NO_IMAGE_STYLE) imageStyle = /** @type {import("../style/Image.js").default} */ styleObject["imageStyle"];
    } else imageStyle = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE;
    const textStyle = /** @type {Text} */ "textStyle" in styleObject ? styleObject["textStyle"] : $1140dfbeee585f32$var$DEFAULT_TEXT_STYLE;
    const strokeStyle = /** @type {Stroke} */ "strokeStyle" in styleObject ? styleObject["strokeStyle"] : $1140dfbeee585f32$var$DEFAULT_STROKE_STYLE;
    const outline = /** @type {boolean|undefined} */ styleObject["outline"];
    if (outline !== undefined && !outline) // if the polystyle specifies no outline two styles are needed,
    // one for non-polygon geometries where linestrings require a stroke
    // and one for polygons where there should be no stroke
    return [
        new (0, $c3RIb.default)({
            geometry: function(feature) {
                const geometry = feature.getGeometry();
                const type = geometry.getType();
                if (type === "GeometryCollection") {
                    const collection = /** @type {import("../geom/GeometryCollection").default} */ geometry;
                    return new (0, $1eatv.default)(collection.getGeometriesArrayRecursive().filter(function(geometry) {
                        const type = geometry.getType();
                        return type !== "Polygon" && type !== "MultiPolygon";
                    }));
                }
                if (type !== "Polygon" && type !== "MultiPolygon") return geometry;
            },
            fill: fillStyle,
            image: imageStyle,
            stroke: strokeStyle,
            text: textStyle,
            zIndex: undefined
        }),
        new (0, $c3RIb.default)({
            geometry: function(feature) {
                const geometry = feature.getGeometry();
                const type = geometry.getType();
                if (type === "GeometryCollection") {
                    const collection = /** @type {import("../geom/GeometryCollection").default} */ geometry;
                    return new (0, $1eatv.default)(collection.getGeometriesArrayRecursive().filter(function(geometry) {
                        const type = geometry.getType();
                        return type === "Polygon" || type === "MultiPolygon";
                    }));
                }
                if (type === "Polygon" || type === "MultiPolygon") return geometry;
            },
            fill: fillStyle,
            stroke: null,
            zIndex: undefined
        })
    ];
    return [
        new (0, $c3RIb.default)({
            fill: fillStyle,
            image: imageStyle,
            stroke: strokeStyle,
            text: textStyle,
            zIndex: undefined
        })
    ];
}
/**
 * Reads an array of geometries and creates arrays for common geometry
 * properties. Then sets them to the multi geometry.
 * @param {MultiPoint|MultiLineString|MultiPolygon} multiGeometry A multi-geometry.
 * @param {Array<import("../geom/Geometry.js").default>} geometries List of geometries.
 */ function $1140dfbeee585f32$var$setCommonGeometryProperties(multiGeometry, geometries) {
    const ii = geometries.length;
    const extrudes = new Array(geometries.length);
    const tessellates = new Array(geometries.length);
    const altitudeModes = new Array(geometries.length);
    let hasExtrude, hasTessellate, hasAltitudeMode;
    hasExtrude = false;
    hasTessellate = false;
    hasAltitudeMode = false;
    for(let i = 0; i < ii; ++i){
        const geometry = geometries[i];
        extrudes[i] = geometry.get("extrude");
        tessellates[i] = geometry.get("tessellate");
        altitudeModes[i] = geometry.get("altitudeMode");
        hasExtrude = hasExtrude || extrudes[i] !== undefined;
        hasTessellate = hasTessellate || tessellates[i] !== undefined;
        hasAltitudeMode = hasAltitudeMode || altitudeModes[i];
    }
    if (hasExtrude) multiGeometry.set("extrude", extrudes);
    if (hasTessellate) multiGeometry.set("tessellate", tessellates);
    if (hasAltitudeMode) multiGeometry.set("altitudeMode", altitudeModes);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$DATA_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "displayName": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "value": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$dataParser(node, objectStack) {
    const name = node.getAttribute("name");
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($1140dfbeee585f32$var$DATA_PARSERS, node, objectStack);
    const featureObject = /** @type {Object} */ objectStack[objectStack.length - 1];
    if (name && featureObject.displayName) featureObject[name] = {
        value: featureObject.value,
        displayName: featureObject.displayName,
        toString: function() {
            return featureObject.value;
        }
    };
    else if (name !== null) featureObject[name] = featureObject.value;
    else if (featureObject.displayName !== null) featureObject[featureObject.displayName] = featureObject.value;
    delete featureObject["value"];
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$EXTENDED_DATA_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "Data": $1140dfbeee585f32$var$dataParser,
    "SchemaData": $1140dfbeee585f32$var$schemaDataParser
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$extendedDataParser(node, objectStack) {
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($1140dfbeee585f32$var$EXTENDED_DATA_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$regionParser(node, objectStack) {
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($1140dfbeee585f32$var$REGION_PARSERS, node, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PAIR_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "Style": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readStyle),
    "key": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "styleUrl": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($1140dfbeee585f32$var$readStyleURL)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$pairDataParser(node, objectStack) {
    const pairObject = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$PAIR_PARSERS, node, objectStack, this);
    if (!pairObject) return;
    const key = /** @type {string|undefined} */ pairObject["key"];
    if (key && key == "normal") {
        const styleUrl = /** @type {string|undefined} */ pairObject["styleUrl"];
        if (styleUrl) objectStack[objectStack.length - 1] = styleUrl;
        const style = /** @type {Style} */ pairObject["Style"];
        if (style) objectStack[objectStack.length - 1] = style;
    }
}
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$placemarkStyleMapParser(node, objectStack) {
    const styleMapValue = $1140dfbeee585f32$var$readStyleMapValue.call(this, node, objectStack);
    if (!styleMapValue) return;
    const placemarkObject = objectStack[objectStack.length - 1];
    if (Array.isArray(styleMapValue)) placemarkObject["Style"] = styleMapValue;
    else if (typeof styleMapValue === "string") placemarkObject["styleUrl"] = styleMapValue;
    else throw new Error("`styleMapValue` has an unknown type");
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$SCHEMA_DATA_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "SimpleData": $1140dfbeee585f32$var$simpleDataParser
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$schemaDataParser(node, objectStack) {
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($1140dfbeee585f32$var$SCHEMA_DATA_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$simpleDataParser(node, objectStack) {
    const name = node.getAttribute("name");
    if (name !== null) {
        const data = (0, $d5e0fde316cac971$export$dda73877cb166cd3)(node);
        const featureObject = /** @type {Object} */ objectStack[objectStack.length - 1];
        featureObject[name] = data;
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LAT_LON_ALT_BOX_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "altitudeMode": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "minAltitude": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "maxAltitude": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "north": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "south": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "east": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "west": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$latLonAltBoxParser(node, objectStack) {
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$LAT_LON_ALT_BOX_PARSERS, node, objectStack);
    if (!object) return;
    const regionObject = /** @type {Object} */ objectStack[objectStack.length - 1];
    const extent = [
        parseFloat(object["west"]),
        parseFloat(object["south"]),
        parseFloat(object["east"]),
        parseFloat(object["north"])
    ];
    regionObject["extent"] = extent;
    regionObject["altitudeMode"] = object["altitudeMode"];
    regionObject["minAltitude"] = parseFloat(object["minAltitude"]);
    regionObject["maxAltitude"] = parseFloat(object["maxAltitude"]);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LOD_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "minLodPixels": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "maxLodPixels": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "minFadeExtent": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "maxFadeExtent": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b))
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$lodParser(node, objectStack) {
    const object = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $1140dfbeee585f32$var$LOD_PARSERS, node, objectStack);
    if (!object) return;
    const lodObject = /** @type {Object} */ objectStack[objectStack.length - 1];
    lodObject["minLodPixels"] = parseFloat(object["minLodPixels"]);
    lodObject["maxLodPixels"] = parseFloat(object["maxLodPixels"]);
    lodObject["minFadeExtent"] = parseFloat(object["minFadeExtent"]);
    lodObject["maxFadeExtent"] = parseFloat(object["maxFadeExtent"]);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$INNER_BOUNDARY_IS_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    // KML spec only allows one LinearRing  per innerBoundaryIs, but Google Earth
    // allows multiple, so we parse multiple here too.
    "LinearRing": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($1140dfbeee585f32$var$readFlatLinearRing)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$innerBoundaryIsParser(node, objectStack) {
    const innerBoundaryFlatLinearRings = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(/** @type {Array<Array<number>>} */ [], $1140dfbeee585f32$var$INNER_BOUNDARY_IS_PARSERS, node, objectStack);
    if (innerBoundaryFlatLinearRings.length > 0) {
        const flatLinearRings = /** @type {Array<Array<number>>} */ objectStack[objectStack.length - 1];
        flatLinearRings.push(...innerBoundaryFlatLinearRings);
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$OUTER_BOUNDARY_IS_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "LinearRing": (0, $a4f89edd2ef65182$export$b1b80676c57c5713)($1140dfbeee585f32$var$readFlatLinearRing)
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$outerBoundaryIsParser(node, objectStack) {
    /** @type {Array<number>|undefined} */ const flatLinearRing = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)(undefined, $1140dfbeee585f32$var$OUTER_BOUNDARY_IS_PARSERS, node, objectStack);
    if (flatLinearRing) {
        const flatLinearRings = /** @type {Array<Array<number>>} */ objectStack[objectStack.length - 1];
        flatLinearRings[0] = flatLinearRing;
    }
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$linkParser(node, objectStack) {
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($1140dfbeee585f32$var$LINK_PARSERS, node, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$whenParser(node, objectStack) {
    const gxTrackObject = /** @type {GxTrackObject} */ objectStack[objectStack.length - 1];
    const whens = gxTrackObject.whens;
    const s = (0, $a4f89edd2ef65182$export$b089dda0fde13047)(node, false);
    const when = Date.parse(s);
    whens.push(isNaN(when) ? 0 : when);
}
/**
 * @param {Node} node Node to append a TextNode with the color to.
 * @param {import("../color.js").Color|string} color Color.
 */ function $1140dfbeee585f32$var$writeColorTextNode(node, color) {
    const rgba = (0, $4iSHH.asArray)(color);
    const opacity = rgba.length == 4 ? rgba[3] : 1;
    /** @type {Array<string|number>} */ const abgr = [
        opacity * 255,
        rgba[2],
        rgba[1],
        rgba[0]
    ];
    for(let i = 0; i < 4; ++i){
        const hex = Math.floor(/** @type {number} */ abgr[i]).toString(16);
        abgr[i] = hex.length == 1 ? "0" + hex : hex;
    }
    (0, $d5e0fde316cac971$export$3255ca5635e70aed)(node, abgr.join(""));
}
/**
 * @param {Node} node Node to append a TextNode with the coordinates to.
 * @param {Array<number>} coordinates Coordinates.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeCoordinatesTextNode(node, coordinates, objectStack) {
    const context = objectStack[objectStack.length - 1];
    const layout = context["layout"];
    const stride = context["stride"];
    let dimension;
    if (layout == "XY" || layout == "XYM") dimension = 2;
    else if (layout == "XYZ" || layout == "XYZM") dimension = 3;
    else throw new Error("Invalid geometry layout");
    const ii = coordinates.length;
    let text = "";
    if (ii > 0) {
        text += coordinates[0];
        for(let d = 1; d < dimension; ++d)text += "," + coordinates[d];
        for(let i = stride; i < ii; i += stride){
            text += " " + coordinates[i];
            for(let d = 1; d < dimension; ++d)text += "," + coordinates[i + d];
        }
    }
    (0, $d5e0fde316cac971$export$3255ca5635e70aed)(node, text);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$EXTENDEDDATA_NODE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "Data": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeDataNode),
    "value": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeDataNodeValue),
    "displayName": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeDataNodeName)
});
/**
 * @param {Element} node Node.
 * @param {{name: *, value: *}} pair Name value pair.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeDataNode(node, pair, objectStack) {
    node.setAttribute("name", pair.name);
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const value = pair.value;
    if (typeof value == "object") {
        if (value !== null && value.displayName) (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$EXTENDEDDATA_NODE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), [
            value.displayName
        ], objectStack, [
            "displayName"
        ]);
        if (value !== null && value.value) (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$EXTENDEDDATA_NODE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), [
            value.value
        ], objectStack, [
            "value"
        ]);
    } else (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$EXTENDEDDATA_NODE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), [
        value
    ], objectStack, [
        "value"
    ]);
}
/**
 * @param {Node} node Node to append a TextNode with the name to.
 * @param {string} name DisplayName.
 */ function $1140dfbeee585f32$var$writeDataNodeName(node, name) {
    (0, $d5e0fde316cac971$export$d6c624180454e8f9)(node, name);
}
/**
 * @param {Node} node Node to append a CDATA Section with the value to.
 * @param {string} value Value.
 */ function $1140dfbeee585f32$var$writeDataNodeValue(node, value) {
    (0, $d5e0fde316cac971$export$3255ca5635e70aed)(node, value);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$DOCUMENT_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "Placemark": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePlacemark)
});
/**
 * @const
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [nodeName] Node name.
 * @return {Node|undefined} Node.
 */ const $1140dfbeee585f32$var$DOCUMENT_NODE_FACTORY = function(value, objectStack, nodeName) {
    const parentNode = objectStack[objectStack.length - 1].node;
    return (0, $a4f89edd2ef65182$export$7094a064528c7fee)(parentNode.namespaceURI, "Placemark");
};
/**
 * @param {Element} node Node.
 * @param {Array<Feature>} features Features.
 * @param {Array<*>} objectStack Object stack.
 * @this {KML}
 */ function $1140dfbeee585f32$var$writeDocument(node, features, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$DOCUMENT_SERIALIZERS, $1140dfbeee585f32$var$DOCUMENT_NODE_FACTORY, features, objectStack, undefined, this);
}
/**
 * A factory for creating Data nodes.
 * @const
 * @type {function(*, Array<*>): (Node|undefined)}
 */ const $1140dfbeee585f32$var$DATA_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)("Data");
/**
 * @param {Element} node Node.
 * @param {{names: Array<string>, values: (Array<*>)}} namesAndValues Names and values.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeExtendedData(node, namesAndValues, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const names = namesAndValues.names;
    const values = namesAndValues.values;
    const length = names.length;
    for(let i = 0; i < length; i++)(0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$EXTENDEDDATA_NODE_SERIALIZERS, $1140dfbeee585f32$var$DATA_NODE_FACTORY, [
        {
            name: names[i],
            value: values[i]
        }
    ], objectStack);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    "href"
], (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, [
    "x",
    "y",
    "w",
    "h"
]));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "href": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed))
}, (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$GX_NAMESPACE_URIS, {
    "x": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "y": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "w": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "h": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1))
}));
/**
 * @const
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [nodeName] Node name.
 * @return {Node|undefined} Node.
 */ const $1140dfbeee585f32$var$GX_NODE_FACTORY = function(value, objectStack, nodeName) {
    return (0, $a4f89edd2ef65182$export$7094a064528c7fee)($1140dfbeee585f32$var$GX_NAMESPACE_URIS[0], "gx:" + nodeName);
};
/**
 * @param {Element} node Node.
 * @param {Object} icon Icon object.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeIcon(node, icon, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const parentNode = objectStack[objectStack.length - 1].node;
    let orderedKeys = $1140dfbeee585f32$var$ICON_SEQUENCE[parentNode.namespaceURI];
    let values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(icon, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$ICON_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
    orderedKeys = $1140dfbeee585f32$var$ICON_SEQUENCE[$1140dfbeee585f32$var$GX_NAMESPACE_URIS[0]];
    values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(icon, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$ICON_SERIALIZERS, $1140dfbeee585f32$var$GX_NODE_FACTORY, values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_STYLE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    "scale",
    "heading",
    "Icon",
    "color",
    "hotSpot"
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$ICON_STYLE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "Icon": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeIcon),
    "color": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeColorTextNode),
    "heading": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "hotSpot": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeVec2),
    "scale": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeScaleTextNode)
});
/**
 * @param {Element} node Node.
 * @param {import("../style/Icon.js").default} style Icon style.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeIconStyle(node, style, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const /** @type {Object<string, any>} */ properties = {};
    const src = style.getSrc();
    const size = style.getSize();
    const iconImageSize = style.getImageSize();
    const iconProperties = {
        "href": src
    };
    if (size) {
        iconProperties["w"] = size[0];
        iconProperties["h"] = size[1];
        const anchor = style.getAnchor(); // top-left
        const origin = style.getOrigin(); // top-left
        if (origin && iconImageSize && origin[0] !== 0 && origin[1] !== size[1]) {
            iconProperties["x"] = origin[0];
            iconProperties["y"] = iconImageSize[1] - (origin[1] + size[1]);
        }
        if (anchor && (anchor[0] !== size[0] / 2 || anchor[1] !== size[1] / 2)) {
            const /** @type {Vec2} */ hotSpot = {
                x: anchor[0],
                xunits: "pixels",
                y: size[1] - anchor[1],
                yunits: "pixels"
            };
            properties["hotSpot"] = hotSpot;
        }
    }
    properties["Icon"] = iconProperties;
    let scale = style.getScaleArray()[0];
    let imageSize = size;
    if (imageSize === null) imageSize = $1140dfbeee585f32$var$DEFAULT_IMAGE_STYLE_SIZE;
    if (imageSize.length == 2) {
        const resizeScale = $1140dfbeee585f32$var$scaleForSize(imageSize);
        scale = scale / resizeScale;
    }
    if (scale !== 1) properties["scale"] = scale;
    const rotation = style.getRotation();
    if (rotation !== 0) properties["heading"] = rotation; // 0-360
    const color = style.getColor();
    if (color) properties["color"] = color;
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$ICON_STYLE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$ICON_STYLE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LABEL_STYLE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    "color",
    "scale"
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LABEL_STYLE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "color": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeColorTextNode),
    "scale": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeScaleTextNode)
});
/**
 * @param {Element} node Node.
 * @param {Text} style style.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeLabelStyle(node, style, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const properties = {};
    const fill = style.getFill();
    if (fill) properties["color"] = fill.getColor();
    const scale = style.getScale();
    if (scale && scale !== 1) properties["scale"] = scale;
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$LABEL_STYLE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$LABEL_STYLE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LINE_STYLE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    "color",
    "width"
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$LINE_STYLE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "color": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeColorTextNode),
    "width": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1))
});
/**
 * @param {Element} node Node.
 * @param {Stroke} style style.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeLineStyle(node, style, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const properties = {
        "color": style.getColor(),
        "width": Number(style.getWidth()) || 1
    };
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$LINE_STYLE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$LINE_STYLE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, string>}
 */ const $1140dfbeee585f32$var$GEOMETRY_TYPE_TO_NODENAME = {
    "Point": "Point",
    "LineString": "LineString",
    "LinearRing": "LinearRing",
    "Polygon": "Polygon",
    "MultiPoint": "MultiGeometry",
    "MultiLineString": "MultiGeometry",
    "MultiPolygon": "MultiGeometry",
    "GeometryCollection": "MultiGeometry"
};
/**
 * @const
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [nodeName] Node name.
 * @return {Node|undefined} Node.
 */ const $1140dfbeee585f32$var$GEOMETRY_NODE_FACTORY = function(value, objectStack, nodeName) {
    if (value) {
        const parentNode = objectStack[objectStack.length - 1].node;
        return (0, $a4f89edd2ef65182$export$7094a064528c7fee)(parentNode.namespaceURI, $1140dfbeee585f32$var$GEOMETRY_TYPE_TO_NODENAME[/** @type {import("../geom/Geometry.js").default} */ value.getType()]);
    }
};
/**
 * A factory for creating Point nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$POINT_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)("Point");
/**
 * A factory for creating LineString nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$LINE_STRING_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)("LineString");
/**
 * A factory for creating LinearRing nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$LINEAR_RING_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)("LinearRing");
/**
 * A factory for creating Polygon nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$POLYGON_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)("Polygon");
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$MULTI_GEOMETRY_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "LineString": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry),
    "Point": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry),
    "Polygon": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePolygon),
    "GeometryCollection": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeMultiGeometry)
});
/**
 * @param {Element} node Node.
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeMultiGeometry(node, geometry, objectStack) {
    /** @type {import("../xml.js").NodeStackItem} */ const context = {
        node: node
    };
    const type = geometry.getType();
    /** @type {Array<import("../geom/Geometry.js").default>} */ let geometries = [];
    /** @type {function(*, Array<*>, string=): (Node|undefined)} */ let factory;
    if (type === "GeometryCollection") {
        /** @type {GeometryCollection} */ geometry.getGeometriesArrayRecursive().forEach(function(geometry) {
            const type = geometry.getType();
            if (type === "MultiPoint") geometries = geometries.concat(/** @type {MultiPoint} */ geometry.getPoints());
            else if (type === "MultiLineString") geometries = geometries.concat(/** @type {MultiLineString} */ geometry.getLineStrings());
            else if (type === "MultiPolygon") geometries = geometries.concat(/** @type {MultiPolygon} */ geometry.getPolygons());
            else if (type === "Point" || type === "LineString" || type === "Polygon") geometries.push(geometry);
            else throw new Error("Unknown geometry type");
        });
        factory = $1140dfbeee585f32$var$GEOMETRY_NODE_FACTORY;
    } else if (type === "MultiPoint") {
        geometries = /** @type {MultiPoint} */ geometry.getPoints();
        factory = $1140dfbeee585f32$var$POINT_NODE_FACTORY;
    } else if (type === "MultiLineString") {
        geometries = /** @type {MultiLineString} */ geometry.getLineStrings();
        factory = $1140dfbeee585f32$var$LINE_STRING_NODE_FACTORY;
    } else if (type === "MultiPolygon") {
        geometries = /** @type {MultiPolygon} */ geometry.getPolygons();
        factory = $1140dfbeee585f32$var$POLYGON_NODE_FACTORY;
    } else throw new Error("Unknown geometry type");
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$MULTI_GEOMETRY_SERIALIZERS, factory, geometries, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$BOUNDARY_IS_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "LinearRing": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry)
});
/**
 * @param {Element} node Node.
 * @param {import("../geom/LinearRing.js").default} linearRing Linear ring.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeBoundaryIs(node, linearRing, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$BOUNDARY_IS_SERIALIZERS, $1140dfbeee585f32$var$LINEAR_RING_NODE_FACTORY, [
        linearRing
    ], objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PLACEMARK_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "ExtendedData": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeExtendedData),
    "MultiGeometry": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeMultiGeometry),
    "LineString": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry),
    "LinearRing": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry),
    "Point": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePrimitiveGeometry),
    "Polygon": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePolygon),
    "Style": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeStyle),
    "address": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "description": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "name": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "open": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7)),
    "phoneNumber": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "styleUrl": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "visibility": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7))
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PLACEMARK_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    "name",
    "open",
    "visibility",
    "address",
    "phoneNumber",
    "description",
    "styleUrl",
    "Style"
]);
/**
 * A factory for creating ExtendedData nodes.
 * @const
 * @type {function(*, Array<*>): (Node|undefined)}
 */ const $1140dfbeee585f32$var$EXTENDEDDATA_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)("ExtendedData");
/**
 * FIXME currently we do serialize arbitrary/custom feature properties
 * (ExtendedData).
 * @param {Element} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 * @this {KML}
 */ function $1140dfbeee585f32$var$writePlacemark(node, feature, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    // set id
    if (feature.getId()) node.setAttribute("id", /** @type {string} */ feature.getId());
    // serialize properties (properties unknown to KML are not serialized)
    const properties = feature.getProperties();
    // don't export these to ExtendedData
    const filter = {
        "address": 1,
        "description": 1,
        "name": 1,
        "open": 1,
        "phoneNumber": 1,
        "styleUrl": 1,
        "visibility": 1
    };
    filter[feature.getGeometryName()] = 1;
    const keys = Object.keys(properties || {}).sort().filter(function(v) {
        return !filter[v];
    });
    const styleFunction = feature.getStyleFunction();
    if (styleFunction) {
        // FIXME the styles returned by the style function are supposed to be
        // resolution-independent here
        const styles = styleFunction(feature, 0);
        if (styles) {
            const styleArray = Array.isArray(styles) ? styles : [
                styles
            ];
            let pointStyles = styleArray;
            if (feature.getGeometry()) {
                pointStyles = styleArray.filter(function(style) {
                    const geometry = style.getGeometryFunction()(feature);
                    if (geometry) {
                        const type = geometry.getType();
                        if (type === "GeometryCollection") return /** @type {GeometryCollection} */ geometry.getGeometriesArrayRecursive().filter(function(geometry) {
                            const type = geometry.getType();
                            return type === "Point" || type === "MultiPoint";
                        }).length;
                        return type === "Point" || type === "MultiPoint";
                    }
                });
                "Point";
            }
            if (this.writeStyles_) {
                let lineStyles = styleArray;
                let polyStyles = styleArray;
                if (feature.getGeometry()) {
                    lineStyles = styleArray.filter(function(style) {
                        const geometry = style.getGeometryFunction()(feature);
                        if (geometry) {
                            const type = geometry.getType();
                            if (type === "GeometryCollection") return /** @type {GeometryCollection} */ geometry.getGeometriesArrayRecursive().filter(function(geometry) {
                                const type = geometry.getType();
                                return type === "LineString" || type === "MultiLineString";
                            }).length;
                            return type === "LineString" || type === "MultiLineString";
                        }
                    });
                    polyStyles = styleArray.filter(function(style) {
                        const geometry = style.getGeometryFunction()(feature);
                        if (geometry) {
                            const type = geometry.getType();
                            if (type === "GeometryCollection") return /** @type {GeometryCollection} */ geometry.getGeometriesArrayRecursive().filter(function(geometry) {
                                const type = geometry.getType();
                                return type === "Polygon" || type === "MultiPolygon";
                            }).length;
                            return type === "Polygon" || type === "MultiPolygon";
                        }
                    });
                }
                properties["Style"] = {
                    pointStyles: pointStyles,
                    lineStyles: lineStyles,
                    polyStyles: polyStyles
                };
            }
            if (pointStyles.length && properties["name"] === undefined) {
                const textStyle = pointStyles[0].getText();
                if (textStyle) properties["name"] = textStyle.getText();
            }
        }
    }
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$PLACEMARK_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$PLACEMARK_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
    if (keys.length > 0) {
        const sequence = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, keys);
        const namesAndValues = {
            names: keys,
            values: sequence
        };
        (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$PLACEMARK_SERIALIZERS, $1140dfbeee585f32$var$EXTENDEDDATA_NODE_FACTORY, [
            namesAndValues
        ], objectStack);
    }
    // serialize geometry
    const options = /** @type {import("./Feature.js").WriteOptions} */ objectStack[0];
    let geometry = feature.getGeometry();
    if (geometry) geometry = (0, $kgouC.transformGeometryWithOptions)(geometry, true, options);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$PLACEMARK_SERIALIZERS, $1140dfbeee585f32$var$GEOMETRY_NODE_FACTORY, [
        geometry
    ], objectStack);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PRIMITIVE_GEOMETRY_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    "extrude",
    "tessellate",
    "altitudeMode",
    "coordinates"
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$PRIMITIVE_GEOMETRY_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "extrude": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7)),
    "tessellate": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7)),
    "altitudeMode": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "coordinates": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeCoordinatesTextNode)
});
/**
 * @param {Element} node Node.
 * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writePrimitiveGeometry(node, geometry, objectStack) {
    const flatCoordinates = geometry.getFlatCoordinates();
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    context["layout"] = geometry.getLayout();
    context["stride"] = geometry.getStride();
    // serialize properties (properties unknown to KML are not serialized)
    const properties = geometry.getProperties();
    properties.coordinates = flatCoordinates;
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$PRIMITIVE_GEOMETRY_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$PRIMITIVE_GEOMETRY_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$POLY_STYLE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    "color",
    "fill",
    "outline"
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$POLYGON_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "outerBoundaryIs": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeBoundaryIs),
    "innerBoundaryIs": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeBoundaryIs)
});
/**
 * A factory for creating innerBoundaryIs nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$INNER_BOUNDARY_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)("innerBoundaryIs");
/**
 * A factory for creating outerBoundaryIs nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $1140dfbeee585f32$var$OUTER_BOUNDARY_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)("outerBoundaryIs");
/**
 * @param {Element} node Node.
 * @param {Polygon} polygon Polygon.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writePolygon(node, polygon, objectStack) {
    const linearRings = polygon.getLinearRings();
    const outerRing = linearRings.shift();
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    // inner rings
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$POLYGON_SERIALIZERS, $1140dfbeee585f32$var$INNER_BOUNDARY_NODE_FACTORY, linearRings, objectStack);
    // outer ring
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$POLYGON_SERIALIZERS, $1140dfbeee585f32$var$OUTER_BOUNDARY_NODE_FACTORY, [
        outerRing
    ], objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$POLY_STYLE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "color": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeColorTextNode),
    "fill": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7)),
    "outline": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$9de8e8a584a450b7))
});
/**
 * @param {Element} node Node.
 * @param {Style} style Style.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writePolyStyle(node, style, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const fill = style.getFill();
    const stroke = style.getStroke();
    const properties = {
        "color": fill ? fill.getColor() : undefined,
        "fill": fill ? undefined : false,
        "outline": stroke ? undefined : false
    };
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$POLY_STYLE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$POLY_STYLE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @param {Node} node Node to append a TextNode with the scale to.
 * @param {number|undefined} scale Scale.
 */ function $1140dfbeee585f32$var$writeScaleTextNode(node, scale) {
    // the Math is to remove any excess decimals created by float arithmetic
    (0, $d5e0fde316cac971$export$f8009f9ca036d7d1)(node, Math.round(scale * 1e6) / 1e6);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$STYLE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, [
    "IconStyle",
    "LabelStyle",
    "LineStyle",
    "PolyStyle"
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $1140dfbeee585f32$var$STYLE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($1140dfbeee585f32$var$NAMESPACE_URIS, {
    "IconStyle": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeIconStyle),
    "LabelStyle": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeLabelStyle),
    "LineStyle": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writeLineStyle),
    "PolyStyle": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($1140dfbeee585f32$var$writePolyStyle)
});
/**
 * @param {Element} node Node.
 * @param {Object<string, Array<Style>>} styles Styles.
 * @param {Array<*>} objectStack Object stack.
 */ function $1140dfbeee585f32$var$writeStyle(node, styles, objectStack) {
    const /** @type {import("../xml.js").NodeStackItem} */ context = {
        node: node
    };
    const properties = {};
    if (styles.pointStyles.length) {
        const textStyle = styles.pointStyles[0].getText();
        if (textStyle) properties["LabelStyle"] = textStyle;
        const imageStyle = styles.pointStyles[0].getImage();
        if (imageStyle && typeof /** @type {?} */ imageStyle.getSrc === "function") properties["IconStyle"] = imageStyle;
    }
    if (styles.lineStyles.length) {
        const strokeStyle = styles.lineStyles[0].getStroke();
        if (strokeStyle) properties["LineStyle"] = strokeStyle;
    }
    if (styles.polyStyles.length) {
        const strokeStyle = styles.polyStyles[0].getStroke();
        if (strokeStyle && !properties["LineStyle"]) properties["LineStyle"] = strokeStyle;
        properties["PolyStyle"] = styles.polyStyles[0];
    }
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $1140dfbeee585f32$var$STYLE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $1140dfbeee585f32$var$STYLE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @param {Element} node Node to append a TextNode with the Vec2 to.
 * @param {Vec2} vec2 Vec2.
 */ function $1140dfbeee585f32$var$writeVec2(node, vec2) {
    node.setAttribute("x", String(vec2.x));
    node.setAttribute("y", String(vec2.y));
    node.setAttribute("xunits", vec2.xunits);
    node.setAttribute("yunits", vec2.yunits);
}
var $1140dfbeee585f32$export$2e2bcd8739ae039 = $1140dfbeee585f32$var$KML;



var $bnthu = parcelRequire("bnthu");
/**
 * @module ol/format/IGC
 */ 
var $dIG9p = parcelRequire("dIG9p");

var $3xcD3 = parcelRequire("3xcD3");
/**
 * @module ol/format/TextFeature
 */ 
var $kgouC = parcelRequire("kgouC");

var $9iPUS = parcelRequire("9iPUS");
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for text feature formats.
 *
 * @abstract
 */ class $2e03ce1a961db7fd$var$TextFeature extends (0, $kgouC.default) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   */ getType() {
        return "text";
    }
    /**
   * Read the feature from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../Feature.js").default} Feature.
   * @api
   */ readFeature(source, options) {
        return this.readFeatureFromText($2e03ce1a961db7fd$var$getText(source), this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../Feature.js").default} Feature.
   */ readFeatureFromText(text, options) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Read the features from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */ readFeatures(source, options) {
        return this.readFeaturesFromText($2e03ce1a961db7fd$var$getText(source), this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<import("../Feature.js").default>} Features.
   */ readFeaturesFromText(text, options) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Read the geometry from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   */ readGeometry(source, options) {
        return this.readGeometryFromText($2e03ce1a961db7fd$var$getText(source), this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromText(text, options) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Read the projection from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   * @api
   */ readProjection(source) {
        return this.readProjectionFromText($2e03ce1a961db7fd$var$getText(source));
    }
    /**
   * @param {string} text Text.
   * @protected
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjectionFromText(text) {
        return this.dataProjection;
    }
    /**
   * Encode a feature as a string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   */ writeFeature(feature, options) {
        return this.writeFeatureText(feature, this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   */ writeFeatureText(feature, options) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   */ writeFeatures(features, options) {
        return this.writeFeaturesText(features, this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   */ writeFeaturesText(features, options) {
        return (0, $9iPUS.abstract)();
    }
    /**
   * Write a single geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Geometry.
   * @api
   */ writeGeometry(geometry, options) {
        return this.writeGeometryText(geometry, this.adaptOptions(options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @protected
   * @return {string} Text.
   */ writeGeometryText(geometry, options) {
        return (0, $9iPUS.abstract)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {string} Text.
 */ function $2e03ce1a961db7fd$var$getText(source) {
    if (typeof source === "string") return source;
    return "";
}
var $2e03ce1a961db7fd$export$2e2bcd8739ae039 = $2e03ce1a961db7fd$var$TextFeature;



var $dpRHA = parcelRequire("dpRHA");

var $kgouC = parcelRequire("kgouC");
/**
 * @typedef {'barometric' | 'gps' | 'none'} IGCZ
 * IGC altitude/z. One of 'barometric', 'gps', 'none'.
 */ /**
 * @const
 * @type {RegExp}
 */ const $a3eff48c5fdb69ef$var$B_RECORD_RE = /^B(\d{2})(\d{2})(\d{2})(\d{2})(\d{5})([NS])(\d{3})(\d{5})([EW])([AV])(\d{5})(\d{5})/;
/**
 * @const
 * @type {RegExp}
 */ const $a3eff48c5fdb69ef$var$H_RECORD_RE = /^H.([A-Z]{3}).*?:(.*)/;
/**
 * @const
 * @type {RegExp}
 */ const $a3eff48c5fdb69ef$var$HFDTE_RECORD_RE = /^HFDTE(\d{2})(\d{2})(\d{2})/;
/**
 * A regular expression matching the newline characters `\r\n`, `\r` and `\n`.
 *
 * @const
 * @type {RegExp}
 */ const $a3eff48c5fdb69ef$var$NEWLINE_RE = /\r\n|\r|\n/;
/**
 * @typedef {Object} Options
 * @property {IGCZ} [altitudeMode='none'] Altitude mode. Possible
 * values are `'barometric'`, `'gps'`, and `'none'`.
 */ /**
 * @classdesc
 * Feature format for `*.igc` flight recording files.
 *
 * As IGC sources contain a single feature,
 * {@link module:ol/format/IGC~IGC#readFeatures} will return the feature in an
 * array
 *
 * @api
 */ class $a3eff48c5fdb69ef$var$IGC extends (0, $2e03ce1a961db7fd$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $dpRHA.get)("EPSG:4326");
        /**
     * @private
     * @type {IGCZ}
     */ this.altitudeMode_ = options.altitudeMode ? options.altitudeMode : "none";
    }
    /**
   * @protected
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../Feature.js").default} Feature.
   */ readFeatureFromText(text, options) {
        const altitudeMode = this.altitudeMode_;
        const lines = text.split($a3eff48c5fdb69ef$var$NEWLINE_RE);
        /** @type {Object<string, string>} */ const properties = {};
        const flatCoordinates = [];
        let year = 2000;
        let month = 0;
        let day = 1;
        let lastDateTime = -1;
        let i, ii;
        for(i = 0, ii = lines.length; i < ii; ++i){
            const line = lines[i];
            let m;
            if (line.charAt(0) == "B") {
                m = $a3eff48c5fdb69ef$var$B_RECORD_RE.exec(line);
                if (m) {
                    const hour = parseInt(m[1], 10);
                    const minute = parseInt(m[2], 10);
                    const second = parseInt(m[3], 10);
                    let y = parseInt(m[4], 10) + parseInt(m[5], 10) / 60000;
                    if (m[6] == "S") y = -y;
                    let x = parseInt(m[7], 10) + parseInt(m[8], 10) / 60000;
                    if (m[9] == "W") x = -x;
                    flatCoordinates.push(x, y);
                    if (altitudeMode != "none") {
                        let z;
                        if (altitudeMode == "gps") z = parseInt(m[11], 10);
                        else if (altitudeMode == "barometric") z = parseInt(m[12], 10);
                        else z = 0;
                        flatCoordinates.push(z);
                    }
                    let dateTime = Date.UTC(year, month, day, hour, minute, second);
                    // Detect UTC midnight wrap around.
                    if (dateTime < lastDateTime) dateTime = Date.UTC(year, month, day + 1, hour, minute, second);
                    flatCoordinates.push(dateTime / 1000);
                    lastDateTime = dateTime;
                }
            } else if (line.charAt(0) == "H") {
                m = $a3eff48c5fdb69ef$var$HFDTE_RECORD_RE.exec(line);
                if (m) {
                    day = parseInt(m[1], 10);
                    month = parseInt(m[2], 10) - 1;
                    year = 2000 + parseInt(m[3], 10);
                } else {
                    m = $a3eff48c5fdb69ef$var$H_RECORD_RE.exec(line);
                    if (m) properties[m[1]] = m[2].trim();
                }
            }
        }
        if (flatCoordinates.length === 0) return null;
        const layout = altitudeMode == "none" ? "XYM" : "XYZM";
        const lineString = new (0, $3xcD3.default)(flatCoordinates, layout);
        const feature = new (0, $dIG9p.default)((0, $kgouC.transformGeometryWithOptions)(lineString, false, options));
        feature.setProperties(properties, true);
        return feature;
    }
    /**
   * @param {string} text Text.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<Feature>} Features.
   */ readFeaturesFromText(text, options) {
        const feature = this.readFeatureFromText(text, options);
        if (feature) return [
            feature
        ];
        return [];
    }
}
var $a3eff48c5fdb69ef$export$2e2bcd8739ae039 = $a3eff48c5fdb69ef$var$IGC;



var $l7vEP = parcelRequire("l7vEP");
/**
 * @module ol/format/GPX
 */ 
var $dIG9p = parcelRequire("dIG9p");

var $3xcD3 = parcelRequire("3xcD3");

var $fw94T = parcelRequire("fw94T");

var $9vPkX = parcelRequire("9vPkX");



var $dpRHA = parcelRequire("dpRHA");


var $kgouC = parcelRequire("kgouC");
/**
 * @const
 * @type {Array<null|string>}
 */ const $c7152e7ae8968a6e$var$NAMESPACE_URIS = [
    null,
    "http://www.topografix.com/GPX/1/0",
    "http://www.topografix.com/GPX/1/1"
];
/**
 * @const
 * @type {string}
 */ const $c7152e7ae8968a6e$var$SCHEMA_LOCATION = "http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd";
/**
 * @const
 * @type {Object<string, function(Node, Array<*>): (Feature|undefined)>}
 */ const $c7152e7ae8968a6e$var$FEATURE_READER = {
    "rte": $c7152e7ae8968a6e$var$readRte,
    "trk": $c7152e7ae8968a6e$var$readTrk,
    "wpt": $c7152e7ae8968a6e$var$readWpt
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$GPX_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "rte": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($c7152e7ae8968a6e$var$readRte),
    "trk": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($c7152e7ae8968a6e$var$readTrk),
    "wpt": (0, $a4f89edd2ef65182$export$18ed2f5932a1b385)($c7152e7ae8968a6e$var$readWpt)
});
/**
 * @typedef {Object} GPXLink
 * @property {string} [text] text
 * @property {string} [type] type
 */ /**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$LINK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "text": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3), "linkText"),
    "type": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3), "linkType")
});
/**
 * @typedef {Object} GPXAuthor
 * @property {string} [name] name
 * @property {string} [email] email
 * @property {GPXLink} [link] link
 */ /**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$AUTHOR_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "name": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "email": $c7152e7ae8968a6e$var$parseEmail,
    "link": $c7152e7ae8968a6e$var$parseLink
});
/**
 * @typedef {Object} GPXMetadata
 * @property {string} [name] name
 * @property {string} [desc] desc
 * @property {GPXAuthor} [author] author
 * @property {GPXLink} [link] link
 * @property {number} [time] time
 * @property {string} [keywords] keywords
 * @property {Array<number>} [bounds] bounds
 * @property {Object} [extensions] extensions
 *
 */ /**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$METADATA_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "name": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "desc": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "author": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($c7152e7ae8968a6e$var$readAuthor),
    "copyright": (0, $a4f89edd2ef65182$export$b69a91976ee81208)($c7152e7ae8968a6e$var$readCopyright),
    "link": $c7152e7ae8968a6e$var$parseLink,
    "time": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5079def2140fe6f2)),
    "keywords": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "bounds": $c7152e7ae8968a6e$var$parseBounds,
    "extensions": $c7152e7ae8968a6e$var$parseExtensions
});
/**
 * @typedef {Object} GPXCopyright
 * @property {string} [author] author
 * @property {number} [year] year
 * @property {string} [license] license
 */ /**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$COPYRIGHT_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "year": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$6161a72ab5b6b722)),
    "license": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3))
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$GPX_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "rte": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeRte),
    "trk": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeTrk),
    "wpt": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeWpt)
});
/**
 * @typedef {Object} Options
 * @property {function(Feature, Node):void} [readExtensions] Callback function
 * to process `extensions` nodes. To prevent memory leaks, this callback function must
 * not store any references to the node. Note that the `extensions`
 * node is not allowed in GPX 1.0. Moreover, only `extensions`
 * nodes from `wpt`, `rte` and `trk` can be processed, as those are
 * directly mapped to a feature.
 */ /**
 * @typedef {Object} LayoutOptions
 * @property {boolean} [hasZ] HasZ.
 * @property {boolean} [hasM] HasM.
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GPX format.
 *
 * Note that {@link module:ol/format/GPX~GPX#readFeature} only reads the first
 * feature of the source.
 *
 * When reading, routes (`<rte>`) are converted into LineString geometries, and
 * tracks (`<trk>`) into MultiLineString. Any properties on route and track
 * waypoints are ignored.
 *
 * When writing, LineString geometries are output as routes (`<rte>`), and
 * MultiLineString as tracks (`<trk>`).
 *
 * @api
 */ class $c7152e7ae8968a6e$var$GPX extends (0, $ce16c3ce3167dc37$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $dpRHA.get)("EPSG:4326");
        /**
     * @type {function(Feature, Node): void|undefined}
     * @private
     */ this.readExtensions_ = options.readExtensions;
    }
    /**
   * @param {Array<Feature>} features List of features.
   * @private
   */ handleReadExtensions_(features) {
        if (!features) features = [];
        for(let i = 0, ii = features.length; i < ii; ++i){
            const feature = features[i];
            if (this.readExtensions_) {
                const extensionsNode = feature.get("extensionsNode_") || null;
                this.readExtensions_(feature, extensionsNode);
            }
            feature.set("extensionsNode_", undefined);
        }
    }
    /**
   * Reads a GPX file's metadata tag, reading among other things:
   *   - the name and description of this GPX
   *   - its author
   *   - the copyright associated with this GPX file
   *
   * Will return null if no metadata tag is present (or no valid source is given).
   *
   * @param {Document|Element|Object|string} source Source.
   * @return {GPXMetadata | null} Metadata
   * @api
   */ readMetadata(source) {
        if (!source) return null;
        if (typeof source === "string") return this.readMetadataFromDocument((0, $a4f89edd2ef65182$export$98e6a39c04603d36)(source));
        if ((0, $a4f89edd2ef65182$export$62858bae88b53fd0)(source)) return this.readMetadataFromDocument(/** @type {Document} */ source);
        return this.readMetadataFromNode(source);
    }
    /**
   * @param {Document} doc Document.
   * @return {GPXMetadata | null} Metadata
   */ readMetadataFromDocument(doc) {
        for(let n = /** @type {Node} */ doc.firstChild; n; n = n.nextSibling)if (n.nodeType === Node.ELEMENT_NODE) {
            const metadata = this.readMetadataFromNode(/** @type {Element} */ n);
            if (metadata) return metadata;
        }
        return null;
    }
    /**
   * @param {Element} node Node.
   * @return {Object} Metadata
   */ readMetadataFromNode(node) {
        if (!$c7152e7ae8968a6e$var$NAMESPACE_URIS.includes(node.namespaceURI)) return null;
        for(let n = node.firstElementChild; n; n = n.nextElementSibling){
            if ($c7152e7ae8968a6e$var$NAMESPACE_URIS.includes(n.namespaceURI) && n.localName === "metadata") return (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $c7152e7ae8968a6e$var$METADATA_PARSERS, n, []);
        }
        return null;
    }
    /**
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {import("../Feature.js").default} Feature.
   */ readFeatureFromNode(node, options) {
        if (!$c7152e7ae8968a6e$var$NAMESPACE_URIS.includes(node.namespaceURI)) return null;
        const featureReader = $c7152e7ae8968a6e$var$FEATURE_READER[node.localName];
        if (!featureReader) return null;
        const feature = featureReader(node, [
            this.getReadOptions(node, options)
        ]);
        if (!feature) return null;
        this.handleReadExtensions_([
            feature
        ]);
        return feature;
    }
    /**
   * @param {Element} node Node.
   * @param {import("./Feature.js").ReadOptions} [options] Options.
   * @return {Array<import("../Feature.js").default>} Features.
   */ readFeaturesFromNode(node, options) {
        if (!$c7152e7ae8968a6e$var$NAMESPACE_URIS.includes(node.namespaceURI)) return [];
        if (node.localName == "gpx") {
            /** @type {Array<Feature>} */ const features = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)([], $c7152e7ae8968a6e$var$GPX_PARSERS, node, [
                this.getReadOptions(node, options)
            ]);
            if (features) {
                this.handleReadExtensions_(features);
                return features;
            }
            return [];
        }
        return [];
    }
    /**
   * Encode an array of features in the GPX format as an XML node.
   * LineString geometries are output as routes (`<rte>`), and MultiLineString
   * as tracks (`<trk>`).
   *
   * @param {Array<Feature>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Options.
   * @return {Node} Node.
   * @api
   */ writeFeaturesNode(features, options) {
        options = this.adaptOptions(options);
        //FIXME Serialize metadata
        const gpx = (0, $a4f89edd2ef65182$export$7094a064528c7fee)("http://www.topografix.com/GPX/1/1", "gpx");
        const xmlnsUri = "http://www.w3.org/2000/xmlns/";
        gpx.setAttributeNS(xmlnsUri, "xmlns:xsi", (0, $a4f89edd2ef65182$export$be284679de3fbea8));
        gpx.setAttributeNS((0, $a4f89edd2ef65182$export$be284679de3fbea8), "xsi:schemaLocation", $c7152e7ae8968a6e$var$SCHEMA_LOCATION);
        gpx.setAttribute("version", "1.1");
        gpx.setAttribute("creator", "OpenLayers");
        (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(/** @type {import("../xml.js").NodeStackItem} */ {
            node: gpx
        }, $c7152e7ae8968a6e$var$GPX_SERIALIZERS, $c7152e7ae8968a6e$var$GPX_NODE_FACTORY, features, [
            options
        ]);
        return gpx;
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$RTE_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "name": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "cmt": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "desc": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "src": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "link": $c7152e7ae8968a6e$var$parseLink,
    "number": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$6161a72ab5b6b722)),
    "extensions": $c7152e7ae8968a6e$var$parseExtensions,
    "type": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "rtept": $c7152e7ae8968a6e$var$parseRtePt
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$RTEPT_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "ele": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "time": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5079def2140fe6f2))
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$TRK_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "name": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "cmt": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "desc": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "src": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "link": $c7152e7ae8968a6e$var$parseLink,
    "number": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$6161a72ab5b6b722)),
    "type": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "extensions": $c7152e7ae8968a6e$var$parseExtensions,
    "trkseg": $c7152e7ae8968a6e$var$parseTrkSeg
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$TRKSEG_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "trkpt": $c7152e7ae8968a6e$var$parseTrkPt
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$TRKPT_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "ele": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "time": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5079def2140fe6f2))
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$WPT_PARSERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "ele": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "time": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5079def2140fe6f2)),
    "magvar": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "geoidheight": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "name": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "cmt": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "desc": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "src": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "link": $c7152e7ae8968a6e$var$parseLink,
    "sym": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "type": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "fix": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$dda73877cb166cd3)),
    "sat": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$6161a72ab5b6b722)),
    "hdop": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "vdop": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "pdop": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "ageofdgpsdata": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$5be9c99d34ad295b)),
    "dgpsid": (0, $a4f89edd2ef65182$export$b69a91976ee81208)((0, $d5e0fde316cac971$export$6161a72ab5b6b722)),
    "extensions": $c7152e7ae8968a6e$var$parseExtensions
});
/**
 * @const
 * @type {Array<string>}
 */ const $c7152e7ae8968a6e$var$LINK_SEQUENCE = [
    "text",
    "type"
];
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$LINK_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "text": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "type": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed))
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$RTE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, [
    "name",
    "cmt",
    "desc",
    "src",
    "link",
    "number",
    "type",
    "rtept"
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$RTE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "name": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "cmt": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "desc": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "src": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "link": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeLink),
    "number": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$b6c828910b813a07)),
    "type": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "rtept": (0, $a4f89edd2ef65182$export$fa227189764d6986)((0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeWptType))
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$RTEPT_TYPE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, [
    "ele",
    "time"
]);
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$TRK_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, [
    "name",
    "cmt",
    "desc",
    "src",
    "link",
    "number",
    "type",
    "trkseg"
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$TRK_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "name": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "cmt": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "desc": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "src": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "link": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeLink),
    "number": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$b6c828910b813a07)),
    "type": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "trkseg": (0, $a4f89edd2ef65182$export$fa227189764d6986)((0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeTrkSeg))
});
/**
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */ const $c7152e7ae8968a6e$var$TRKSEG_NODE_FACTORY = (0, $a4f89edd2ef65182$export$7989129829daaabf)("trkpt");
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$TRKSEG_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "trkpt": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeWptType)
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$WPT_TYPE_SEQUENCE = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, [
    "ele",
    "time",
    "magvar",
    "geoidheight",
    "name",
    "cmt",
    "desc",
    "src",
    "link",
    "sym",
    "type",
    "fix",
    "sat",
    "hdop",
    "vdop",
    "pdop",
    "ageofdgpsdata",
    "dgpsid"
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */ // @ts-ignore
const $c7152e7ae8968a6e$var$WPT_TYPE_SERIALIZERS = (0, $a4f89edd2ef65182$export$c6eb0402f939765f)($c7152e7ae8968a6e$var$NAMESPACE_URIS, {
    "ele": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "time": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$4e91791cb8677e27)),
    "magvar": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "geoidheight": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "name": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "cmt": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "desc": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "src": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "link": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)($c7152e7ae8968a6e$var$writeLink),
    "sym": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "type": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "fix": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$3255ca5635e70aed)),
    "sat": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$b6c828910b813a07)),
    "hdop": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "vdop": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "pdop": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "ageofdgpsdata": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$f8009f9ca036d7d1)),
    "dgpsid": (0, $a4f89edd2ef65182$export$77b73fc7f982cc07)((0, $d5e0fde316cac971$export$b6c828910b813a07))
});
/**
 * @const
 * @type {Object<string, string>}
 */ const $c7152e7ae8968a6e$var$GEOMETRY_TYPE_TO_NODENAME = {
    "Point": "wpt",
    "LineString": "rte",
    "MultiLineString": "trk"
};
/**
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [nodeName] Node name.
 * @return {Node|undefined} Node.
 */ function $c7152e7ae8968a6e$var$GPX_NODE_FACTORY(value, objectStack, nodeName) {
    const geometry = /** @type {Feature} */ value.getGeometry();
    if (geometry) {
        const nodeName = $c7152e7ae8968a6e$var$GEOMETRY_TYPE_TO_NODENAME[geometry.getType()];
        if (nodeName) {
            const parentNode = objectStack[objectStack.length - 1].node;
            return (0, $a4f89edd2ef65182$export$7094a064528c7fee)(parentNode.namespaceURI, nodeName);
        }
    }
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {LayoutOptions} layoutOptions Layout options.
 * @param {Element} node Node.
 * @param {!Object} values Values.
 * @return {Array<number>} Flat coordinates.
 */ function $c7152e7ae8968a6e$var$appendCoordinate(flatCoordinates, layoutOptions, node, values) {
    flatCoordinates.push(parseFloat(node.getAttribute("lon")), parseFloat(node.getAttribute("lat")));
    if ("ele" in values) {
        flatCoordinates.push(/** @type {number} */ values["ele"]);
        delete values["ele"];
        layoutOptions.hasZ = true;
    } else flatCoordinates.push(0);
    if ("time" in values) {
        flatCoordinates.push(/** @type {number} */ values["time"]);
        delete values["time"];
        layoutOptions.hasM = true;
    } else flatCoordinates.push(0);
    return flatCoordinates;
}
/**
 * Choose GeometryLayout based on flags in layoutOptions and adjust flatCoordinates
 * and ends arrays by shrinking them accordingly (removing unused zero entries).
 *
 * @param {LayoutOptions} layoutOptions Layout options.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {Array<number>} [ends] Ends.
 * @return {import("../geom/Geometry.js").GeometryLayout} Layout.
 */ function $c7152e7ae8968a6e$var$applyLayoutOptions(layoutOptions, flatCoordinates, ends) {
    /** @type {import("../geom/Geometry.js").GeometryLayout} */ let layout = "XY";
    let stride = 2;
    if (layoutOptions.hasZ && layoutOptions.hasM) {
        layout = "XYZM";
        stride = 4;
    } else if (layoutOptions.hasZ) {
        layout = "XYZ";
        stride = 3;
    } else if (layoutOptions.hasM) {
        layout = "XYM";
        stride = 3;
    }
    if (stride !== 4) {
        for(let i = 0, ii = flatCoordinates.length / 4; i < ii; i++){
            flatCoordinates[i * stride] = flatCoordinates[i * 4];
            flatCoordinates[i * stride + 1] = flatCoordinates[i * 4 + 1];
            if (layoutOptions.hasZ) flatCoordinates[i * stride + 2] = flatCoordinates[i * 4 + 2];
            if (layoutOptions.hasM) flatCoordinates[i * stride + 2] = flatCoordinates[i * 4 + 3];
        }
        flatCoordinates.length = flatCoordinates.length / 4 * stride;
        if (ends) for(let i = 0, ii = ends.length; i < ii; i++)ends[i] = ends[i] / 4 * stride;
    }
    return layout;
}
/**
 * @param {Element} node Node.
 * @param {Array<any>} objectStack Object stack.
 * @return {GPXAuthor | undefined} Person object.
 */ function $c7152e7ae8968a6e$var$readAuthor(node, objectStack) {
    const values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $c7152e7ae8968a6e$var$AUTHOR_PARSERS, node, objectStack);
    if (values) return values;
    return undefined;
}
/**
 * @param {Element} node Node.
 * @param {Array<any>} objectStack Object stack.
 * @return {GPXCopyright | undefined} Person object.
 */ function $c7152e7ae8968a6e$var$readCopyright(node, objectStack) {
    const values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $c7152e7ae8968a6e$var$COPYRIGHT_PARSERS, node, objectStack);
    if (values) {
        const author = node.getAttribute("author");
        if (author !== null) values["author"] = author;
        return values;
    }
    return undefined;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseBounds(node, objectStack) {
    const values = /** @type {Object} */ objectStack[objectStack.length - 1];
    const minlat = node.getAttribute("minlat");
    const minlon = node.getAttribute("minlon");
    const maxlat = node.getAttribute("maxlat");
    const maxlon = node.getAttribute("maxlon");
    if (minlon !== null && minlat !== null && maxlon !== null && maxlat !== null) values["bounds"] = [
        [
            parseFloat(minlon),
            parseFloat(minlat)
        ],
        [
            parseFloat(maxlon),
            parseFloat(maxlat)
        ]
    ];
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseEmail(node, objectStack) {
    const values = /** @type {Object} */ objectStack[objectStack.length - 1];
    const id = node.getAttribute("id");
    const domain = node.getAttribute("domain");
    if (id !== null && domain !== null) values["email"] = `${id}@${domain}`;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseLink(node, objectStack) {
    const values = /** @type {Object} */ objectStack[objectStack.length - 1];
    const href = node.getAttribute("href");
    if (href !== null) values["link"] = href;
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($c7152e7ae8968a6e$var$LINK_PARSERS, node, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseExtensions(node, objectStack) {
    const values = /** @type {Object} */ objectStack[objectStack.length - 1];
    values["extensionsNode_"] = node;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseRtePt(node, objectStack) {
    const values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $c7152e7ae8968a6e$var$RTEPT_PARSERS, node, objectStack);
    if (values) {
        const rteValues = /** @type {!Object} */ objectStack[objectStack.length - 1];
        const flatCoordinates = /** @type {Array<number>} */ rteValues["flatCoordinates"];
        const layoutOptions = /** @type {LayoutOptions} */ rteValues["layoutOptions"];
        $c7152e7ae8968a6e$var$appendCoordinate(flatCoordinates, layoutOptions, node, values);
    }
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseTrkPt(node, objectStack) {
    const values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $c7152e7ae8968a6e$var$TRKPT_PARSERS, node, objectStack);
    if (values) {
        const trkValues = /** @type {!Object} */ objectStack[objectStack.length - 1];
        const flatCoordinates = /** @type {Array<number>} */ trkValues["flatCoordinates"];
        const layoutOptions = /** @type {LayoutOptions} */ trkValues["layoutOptions"];
        $c7152e7ae8968a6e$var$appendCoordinate(flatCoordinates, layoutOptions, node, values);
    }
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$parseTrkSeg(node, objectStack) {
    const values = /** @type {Object} */ objectStack[objectStack.length - 1];
    (0, $a4f89edd2ef65182$export$dc8ce45ce1679f4f)($c7152e7ae8968a6e$var$TRKSEG_PARSERS, node, objectStack);
    const flatCoordinates = /** @type {Array<number>} */ values["flatCoordinates"];
    const ends = /** @type {Array<number>} */ values["ends"];
    ends.push(flatCoordinates.length);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Feature|undefined} Track.
 */ function $c7152e7ae8968a6e$var$readRte(node, objectStack) {
    const options = /** @type {import("./Feature.js").ReadOptions} */ objectStack[0];
    const values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({
        "flatCoordinates": [],
        "layoutOptions": {}
    }, $c7152e7ae8968a6e$var$RTE_PARSERS, node, objectStack);
    if (!values) return undefined;
    const flatCoordinates = /** @type {Array<number>} */ values["flatCoordinates"];
    delete values["flatCoordinates"];
    const layoutOptions = /** @type {LayoutOptions} */ values["layoutOptions"];
    delete values["layoutOptions"];
    const layout = $c7152e7ae8968a6e$var$applyLayoutOptions(layoutOptions, flatCoordinates);
    const geometry = new (0, $3xcD3.default)(flatCoordinates, layout);
    (0, $kgouC.transformGeometryWithOptions)(geometry, false, options);
    const feature = new (0, $dIG9p.default)(geometry);
    feature.setProperties(values, true);
    return feature;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Feature|undefined} Track.
 */ function $c7152e7ae8968a6e$var$readTrk(node, objectStack) {
    const options = /** @type {import("./Feature.js").ReadOptions} */ objectStack[0];
    const values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({
        "flatCoordinates": [],
        "ends": [],
        "layoutOptions": {}
    }, $c7152e7ae8968a6e$var$TRK_PARSERS, node, objectStack);
    if (!values) return undefined;
    const flatCoordinates = /** @type {Array<number>} */ values["flatCoordinates"];
    delete values["flatCoordinates"];
    const ends = /** @type {Array<number>} */ values["ends"];
    delete values["ends"];
    const layoutOptions = /** @type {LayoutOptions} */ values["layoutOptions"];
    delete values["layoutOptions"];
    const layout = $c7152e7ae8968a6e$var$applyLayoutOptions(layoutOptions, flatCoordinates, ends);
    const geometry = new (0, $fw94T.default)(flatCoordinates, layout, ends);
    (0, $kgouC.transformGeometryWithOptions)(geometry, false, options);
    const feature = new (0, $dIG9p.default)(geometry);
    feature.setProperties(values, true);
    return feature;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Feature|undefined} Waypoint.
 */ function $c7152e7ae8968a6e$var$readWpt(node, objectStack) {
    const options = /** @type {import("./Feature.js").ReadOptions} */ objectStack[0];
    const values = (0, $a4f89edd2ef65182$export$5c934df85741dbd1)({}, $c7152e7ae8968a6e$var$WPT_PARSERS, node, objectStack);
    if (!values) return undefined;
    const layoutOptions = /** @type {LayoutOptions} */ {};
    const coordinates = $c7152e7ae8968a6e$var$appendCoordinate([], layoutOptions, node, values);
    const layout = $c7152e7ae8968a6e$var$applyLayoutOptions(layoutOptions, coordinates);
    const geometry = new (0, $9vPkX.default)(coordinates, layout);
    (0, $kgouC.transformGeometryWithOptions)(geometry, false, options);
    const feature = new (0, $dIG9p.default)(geometry);
    feature.setProperties(values, true);
    return feature;
}
/**
 * @param {Element} node Node.
 * @param {string} value Value for the link's `href` attribute.
 * @param {Array<*>} objectStack Node stack.
 */ function $c7152e7ae8968a6e$var$writeLink(node, value, objectStack) {
    node.setAttribute("href", value);
    const context = objectStack[objectStack.length - 1];
    const properties = context["properties"];
    const link = [
        properties["linkText"],
        properties["linkType"]
    ];
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(/** @type {import("../xml.js").NodeStackItem} */ {
        node: node
    }, $c7152e7ae8968a6e$var$LINK_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), link, objectStack, $c7152e7ae8968a6e$var$LINK_SEQUENCE);
}
/**
 * @param {Element} node Node.
 * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$writeWptType(node, coordinate, objectStack) {
    const context = objectStack[objectStack.length - 1];
    const parentNode = context.node;
    const namespaceURI = parentNode.namespaceURI;
    const properties = context["properties"];
    //FIXME Projection handling
    node.setAttributeNS(null, "lat", String(coordinate[1]));
    node.setAttributeNS(null, "lon", String(coordinate[0]));
    const geometryLayout = context["geometryLayout"];
    switch(geometryLayout){
        case "XYZM":
            if (coordinate[3] !== 0) properties["time"] = coordinate[3];
        // fall through
        case "XYZ":
            if (coordinate[2] !== 0) properties["ele"] = coordinate[2];
            break;
        case "XYM":
            if (coordinate[2] !== 0) properties["time"] = coordinate[2];
            break;
        default:
    }
    const orderedKeys = node.nodeName == "rtept" ? $c7152e7ae8968a6e$var$RTEPT_TYPE_SEQUENCE[namespaceURI] : $c7152e7ae8968a6e$var$WPT_TYPE_SEQUENCE[namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(/** @type {import("../xml.js").NodeStackItem} */ {
        node: node,
        "properties": properties
    }, $c7152e7ae8968a6e$var$WPT_TYPE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @param {Node} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$writeRte(node, feature, objectStack) {
    const options = /** @type {import("./Feature.js").WriteOptions} */ objectStack[0];
    const properties = feature.getProperties();
    const context = {
        node: node
    };
    context["properties"] = properties;
    const geometry = feature.getGeometry();
    if (geometry.getType() == "LineString") {
        const lineString = /** @type {LineString} */ (0, $kgouC.transformGeometryWithOptions)(geometry, true, options);
        context["geometryLayout"] = lineString.getLayout();
        properties["rtept"] = lineString.getCoordinates();
    }
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $c7152e7ae8968a6e$var$RTE_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $c7152e7ae8968a6e$var$RTE_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @param {Element} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$writeTrk(node, feature, objectStack) {
    const options = /** @type {import("./Feature.js").WriteOptions} */ objectStack[0];
    const properties = feature.getProperties();
    /** @type {import("../xml.js").NodeStackItem} */ const context = {
        node: node
    };
    context["properties"] = properties;
    const geometry = feature.getGeometry();
    if (geometry.getType() == "MultiLineString") {
        const multiLineString = /** @type {MultiLineString} */ (0, $kgouC.transformGeometryWithOptions)(geometry, true, options);
        properties["trkseg"] = multiLineString.getLineStrings();
    }
    const parentNode = objectStack[objectStack.length - 1].node;
    const orderedKeys = $c7152e7ae8968a6e$var$TRK_SEQUENCE[parentNode.namespaceURI];
    const values = (0, $a4f89edd2ef65182$export$939885a13683f4dc)(properties, orderedKeys);
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $c7152e7ae8968a6e$var$TRK_SERIALIZERS, (0, $a4f89edd2ef65182$export$d91b08b611cef144), values, objectStack, orderedKeys);
}
/**
 * @param {Element} node Node.
 * @param {LineString} lineString LineString.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$writeTrkSeg(node, lineString, objectStack) {
    /** @type {import("../xml.js").NodeStackItem} */ const context = {
        node: node
    };
    context["geometryLayout"] = lineString.getLayout();
    context["properties"] = {};
    (0, $a4f89edd2ef65182$export$a79a01f4edad8da8)(context, $c7152e7ae8968a6e$var$TRKSEG_SERIALIZERS, $c7152e7ae8968a6e$var$TRKSEG_NODE_FACTORY, lineString.getCoordinates(), objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 */ function $c7152e7ae8968a6e$var$writeWpt(node, feature, objectStack) {
    const options = /** @type {import("./Feature.js").WriteOptions} */ objectStack[0];
    const context = objectStack[objectStack.length - 1];
    context["properties"] = feature.getProperties();
    const geometry = feature.getGeometry();
    if (geometry.getType() == "Point") {
        const point = /** @type {Point} */ (0, $kgouC.transformGeometryWithOptions)(geometry, true, options);
        context["geometryLayout"] = point.getLayout();
        $c7152e7ae8968a6e$var$writeWptType(node, point.getCoordinates(), objectStack);
    }
}
var $c7152e7ae8968a6e$export$2e2bcd8739ae039 = $c7152e7ae8968a6e$var$GPX;



var $5ydre = parcelRequire("5ydre");
/**
 * @module ol/interaction/DragAndDrop
 */ // FIXME should handle all geo-referenced data, not just vector data

var $f18Q2 = parcelRequire("f18Q2");

var $3xzSb = parcelRequire("3xzSb");

var $4U60I = parcelRequire("4U60I");

var $6wUzV = parcelRequire("6wUzV");

var $dpRHA = parcelRequire("dpRHA");

var $ilM9F = parcelRequire("ilM9F");
/**
 * @typedef {Object} Options
 * @property {Array<typeof import("../format/Feature.js").default|import("../format/Feature.js").default>} [formatConstructors] Format constructors
 * (and/or formats pre-constructed with options).
 * @property {import("../source/Vector.js").default} [source] Optional vector source where features will be added.  If a source is provided
 * all existing features will be removed and new features will be added when
 * they are dropped on the target.  If you want to add features to a vector
 * source without removing the existing features (append only), instead of
 * providing the source option listen for the "addfeatures" event.
 * @property {import("../proj.js").ProjectionLike} [projection] Target projection. By default, the map's view's projection is used.
 * @property {HTMLElement} [target] The element that is used as the drop target, default is the viewport element.
 */ /**
 * @enum {string}
 */ const $9b46bac5c293ebb3$var$DragAndDropEventType = {
    /**
   * Triggered when features are added
   * @event DragAndDropEvent#addfeatures
   * @api
   */ ADD_FEATURES: "addfeatures"
};
class $9b46bac5c293ebb3$export$5ac429618e6d21e6 extends (0, $f18Q2.default) {
    /**
   * @param {DragAndDropEventType} type Type.
   * @param {File} file File.
   * @param {Array<import("../Feature.js").default>} [features] Features.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   */ constructor(type, file, features, projection){
        super(type);
        /**
     * The features parsed from dropped data.
     * @type {Array<import("../Feature.js").FeatureLike>|undefined}
     * @api
     */ this.features = features;
        /**
     * The dropped file.
     * @type {File}
     * @api
     */ this.file = file;
        /**
     * The feature projection.
     * @type {import("../proj/Projection.js").default|undefined}
     * @api
     */ this.projection = projection;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'addfeatures', DragAndDropEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'addfeatures', Return>} DragAndDropOnSignature
 */ /**
 * @classdesc
 * Handles input of vector data by drag and drop.
 *
 * @api
 *
 * @fires DragAndDropEvent
 */ class $9b46bac5c293ebb3$var$DragAndDrop extends (0, $4U60I.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            handleEvent: (0, $6wUzV.TRUE)
        });
        /***
     * @type {DragAndDropOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DragAndDropOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DragAndDropOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {boolean}
     */ this.readAsBuffer_ = false;
        /**
     * @private
     * @type {Array<import("../format/Feature.js").default>}
     */ this.formats_ = [];
        const formatConstructors = options.formatConstructors ? options.formatConstructors : [];
        for(let i = 0, ii = formatConstructors.length; i < ii; ++i){
            let format = formatConstructors[i];
            if (typeof format === "function") format = new format();
            this.formats_.push(format);
            this.readAsBuffer_ = this.readAsBuffer_ || format.getType() === "arraybuffer";
        }
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.projection_ = options.projection ? (0, $dpRHA.get)(options.projection) : null;
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.dropListenKeys_ = null;
        /**
     * @private
     * @type {import("../source/Vector.js").default}
     */ this.source_ = options.source || null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.target = options.target ? options.target : null;
    }
    /**
   * @param {File} file File.
   * @param {Event} event Load event.
   * @private
   */ handleResult_(file, event) {
        const result = event.target.result;
        const map = this.getMap();
        let projection = this.projection_;
        if (!projection) {
            projection = (0, $dpRHA.getUserProjection)();
            if (!projection) {
                const view = map.getView();
                projection = view.getProjection();
            }
        }
        let text;
        const formats = this.formats_;
        for(let i = 0, ii = formats.length; i < ii; ++i){
            const format = formats[i];
            let input = result;
            if (this.readAsBuffer_ && format.getType() !== "arraybuffer") {
                if (text === undefined) text = new TextDecoder().decode(result);
                input = text;
            }
            const features = this.tryReadFeatures_(format, input, {
                featureProjection: projection
            });
            if (features && features.length > 0) {
                if (this.source_) {
                    this.source_.clear();
                    this.source_.addFeatures(features);
                }
                this.dispatchEvent(new $9b46bac5c293ebb3$export$5ac429618e6d21e6($9b46bac5c293ebb3$var$DragAndDropEventType.ADD_FEATURES, file, features, projection));
                break;
            }
        }
    }
    /**
   * @private
   */ registerListeners_() {
        const map = this.getMap();
        if (map) {
            const dropArea = this.target ? this.target : map.getViewport();
            this.dropListenKeys_ = [
                (0, $ilM9F.listen)(dropArea, (0, $3xzSb.default).DROP, this.handleDrop, this),
                (0, $ilM9F.listen)(dropArea, (0, $3xzSb.default).DRAGENTER, this.handleStop, this),
                (0, $ilM9F.listen)(dropArea, (0, $3xzSb.default).DRAGOVER, this.handleStop, this),
                (0, $ilM9F.listen)(dropArea, (0, $3xzSb.default).DROP, this.handleStop, this)
            ];
        }
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        if (!this.getActive() && active) this.registerListeners_();
        if (this.getActive() && !active) this.unregisterListeners_();
        super.setActive(active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   */ setMap(map) {
        this.unregisterListeners_();
        super.setMap(map);
        if (this.getActive()) this.registerListeners_();
    }
    /**
   * @param {import("../format/Feature.js").default} format Format.
   * @param {string} text Text.
   * @param {import("../format/Feature.js").ReadOptions} options Read options.
   * @private
   * @return {Array<import("../Feature.js").default>} Features.
   */ tryReadFeatures_(format, text, options) {
        try {
            return /** @type {Array<import("../Feature.js").default>} */ format.readFeatures(text, options);
        } catch (e) {
            return null;
        }
    }
    /**
   * @private
   */ unregisterListeners_() {
        if (this.dropListenKeys_) {
            this.dropListenKeys_.forEach((0, $ilM9F.unlistenByKey));
            this.dropListenKeys_ = null;
        }
    }
    /**
   * @param {DragEvent} event Event.
   */ handleDrop(event) {
        const files = event.dataTransfer.files;
        for(let i = 0, ii = files.length; i < ii; ++i){
            const file = files.item(i);
            const reader = new FileReader();
            reader.addEventListener((0, $3xzSb.default).LOAD, this.handleResult_.bind(this, file));
            if (this.readAsBuffer_) reader.readAsArrayBuffer(file);
            else reader.readAsText(file);
        }
    }
    /**
   * @param {DragEvent} event Event.
   */ handleStop(event) {
        event.stopPropagation();
        event.preventDefault();
        event.dataTransfer.dropEffect = "copy";
    }
}
var $9b46bac5c293ebb3$export$2e2bcd8739ae039 = $9b46bac5c293ebb3$var$DragAndDrop;



var $le5ya = parcelRequire("le5ya");

var $bdrRp = parcelRequire("bdrRp");

var $dpRHA = parcelRequire("dpRHA");

var $bV0pP = parcelRequire("bV0pP");
const $927f48c83533ce78$var$iconFeature = new (0, $dIG9p.default)({
    geometry: new (0, $9vPkX.default)([
        700000,
        200000,
        100000
    ])
});
const $927f48c83533ce78$var$textFeature = new (0, $dIG9p.default)({
    geometry: new (0, $9vPkX.default)([
        1000000,
        3000000,
        500000
    ])
});
const $927f48c83533ce78$var$cervinFeature = new (0, $dIG9p.default)({
    geometry: new (0, $9vPkX.default)([
        852541,
        5776649
    ])
});
$927f48c83533ce78$var$cervinFeature.getGeometry().set("altitudeMode", "clampToGround");
const $927f48c83533ce78$var$modelFeatures = [
    -1,
    -0.5,
    0,
    0.5,
    1,
    1.5
].map((factor)=>new (0, $dIG9p.default)({
        geometry: new (0, $9vPkX.default)([
            852641,
            5776749,
            4500
        ]),
        "rotation": factor * Math.PI
    }));
const $927f48c83533ce78$var$iconStyle = new (0, $c3RIb.default)({
    image: new (0, $bmHVE.default)(/** @type {olx.style.IconOptions} */ {
        anchor: [
            0.5,
            46
        ],
        anchorXUnits: "fraction",
        anchorYUnits: "pixels",
        opacity: 0.75,
        src: "data/icon.png"
    }),
    text: new (0, $cJntk.default)({
        text: "Some text",
        textAlign: "center",
        textBaseline: "middle",
        stroke: new (0, $lrKvI.default)({
            color: "magenta",
            width: 3
        }),
        fill: new (0, $inIMS.default)({
            color: "rgba(0, 0, 155, 0.3)"
        })
    })
});
const $927f48c83533ce78$var$textStyle = [
    new (0, $c3RIb.default)({
        text: new (0, $cJntk.default)({
            text: "Only text",
            textAlign: "center",
            textBaseline: "middle",
            stroke: new (0, $lrKvI.default)({
                color: "red",
                width: 3
            }),
            fill: new (0, $inIMS.default)({
                color: "rgba(0, 0, 155, 0.3)"
            })
        })
    }),
    new (0, $c3RIb.default)({
        geometry: new (0, $l7VLp.default)([
            1000000,
            3000000,
            10000
        ], 2e6),
        stroke: new (0, $lrKvI.default)({
            color: "blue",
            width: 2
        }),
        fill: new (0, $inIMS.default)({
            color: "rgba(0, 0, 255, 0.2)"
        })
    })
];
$927f48c83533ce78$var$iconFeature.setStyle($927f48c83533ce78$var$iconStyle);
$927f48c83533ce78$var$textFeature.setStyle($927f48c83533ce78$var$textStyle);
$927f48c83533ce78$var$cervinFeature.setStyle($927f48c83533ce78$var$iconStyle);
let $927f48c83533ce78$var$iCase = 0;
$927f48c83533ce78$var$modelFeatures.forEach((feature)=>{
    ++$927f48c83533ce78$var$iCase;
    const modelStyle = new (0, $c3RIb.default)({
        image: new (0, $bmHVE.default)(/** @type {olx.style.IconOptions} */ {
            anchor: [
                0.5,
                46
            ],
            anchorXUnits: "fraction",
            anchorYUnits: "pixels",
            opacity: 0.75,
            src: "data/icon.png"
        })
    });
    const olcsModelFunction = ()=>{
        const coordinates = feature.getGeometry().getCoordinates();
        const center = (0, $dpRHA.transform)(coordinates, "EPSG:3857", "EPSG:4326");
        const rotation = /** @type {number} */ feature.get("rotation");
        return {
            cesiumOptions: {
                url: "./data/Box.gltf",
                modelMatrix: (0, $cc3xD.createMatrixAtCoordinates)(center, rotation),
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                minimumPixelSize: 64
            }
        };
    };
    let host = feature;
    switch($927f48c83533ce78$var$iCase % 3){
        case 0:
            host = feature.getGeometry();
            break;
        case 1:
            modelStyle.setGeometry(feature.getGeometry().clone());
            host = modelStyle.getGeometry();
            break;
        default:
            host = feature;
    }
    host.set("olcs_model", olcsModelFunction);
    feature.setStyle(modelStyle);
});
const $927f48c83533ce78$var$image = new (0, $wnhPR.default)({
    radius: 5,
    fill: null,
    stroke: new (0, $lrKvI.default)({
        color: "red",
        width: 1
    })
});
const $927f48c83533ce78$var$styles = {
    "Point": [
        new (0, $c3RIb.default)({
            image: $927f48c83533ce78$var$image
        })
    ],
    "LineString": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "green",
                lineDash: [
                    12
                ],
                width: 10
            })
        })
    ],
    "MultiLineString": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "green",
                width: 10
            })
        })
    ],
    "MultiPoint": [
        new (0, $c3RIb.default)({
            image: $927f48c83533ce78$var$image,
            text: new (0, $cJntk.default)({
                text: "MP",
                stroke: new (0, $lrKvI.default)({
                    color: "purple"
                })
            })
        })
    ],
    "MultiPolygon": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "yellow",
                width: 1
            }),
            fill: new (0, $inIMS.default)({
                color: "rgba(255, 255, 0, 0.1)"
            })
        })
    ],
    "Polygon": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "blue",
                lineDash: [
                    4
                ],
                width: 3
            }),
            fill: new (0, $inIMS.default)({
                color: "rgba(0, 0, 255, 0.1)"
            })
        })
    ],
    "GeometryCollection": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "magenta",
                width: 2
            }),
            fill: new (0, $inIMS.default)({
                color: "magenta"
            }),
            image: new (0, $wnhPR.default)({
                radius: 10,
                fill: null,
                stroke: new (0, $lrKvI.default)({
                    color: "magenta"
                })
            })
        })
    ],
    "Circle": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "red",
                width: 2
            }),
            fill: new (0, $inIMS.default)({
                color: "rgba(255,0,0,0.2)"
            })
        })
    ]
};
const $927f48c83533ce78$var$styleFunction = function(feature, resolution) {
    const geo = feature.getGeometry();
    // always assign a style to prevent feature skipping
    return geo ? $927f48c83533ce78$var$styles[geo.getType()] : $927f48c83533ce78$var$styles["Point"];
};
const $927f48c83533ce78$var$vectorSource = new (0, $bnthu.default)({
    format: new (0, $l7vEP.default)(),
    url: "data/geojson/vector_data.geojson"
});
const $927f48c83533ce78$var$theCircle = new (0, $dIG9p.default)(new (0, $l7VLp.default)([
    5e6,
    7e6,
    5e5
], 1e6));
// Add a Cesium rectangle, via setting the property olcs.polygon_kind
const $927f48c83533ce78$var$cartographicRectangleStyle = new (0, $c3RIb.default)({
    fill: new (0, $inIMS.default)({
        color: "rgba(255, 69, 0, 0.7)"
    }),
    stroke: new (0, $lrKvI.default)({
        color: "rgba(255, 69, 0, 0.9)",
        width: 1
    })
});
const $927f48c83533ce78$var$cartographicRectangleGeometry = new (0, $5ydre.default)([
    [
        [
            -5000000,
            11e6
        ],
        [
            4e6,
            11e6
        ],
        [
            4e6,
            10.5e6
        ],
        [
            -5000000,
            10.5e6
        ],
        [
            -5000000,
            11e6
        ]
    ]
]);
$927f48c83533ce78$var$cartographicRectangleGeometry.set("olcs_polygon_kind", "rectangle");
const $927f48c83533ce78$var$cartographicRectangle = new (0, $dIG9p.default)({
    geometry: $927f48c83533ce78$var$cartographicRectangleGeometry
});
$927f48c83533ce78$var$cartographicRectangle.setStyle($927f48c83533ce78$var$cartographicRectangleStyle);
// Add two Cesium rectangles with height and the property olcs.polygon_kind
const $927f48c83533ce78$var$cartographicRectangleGeometry2 = new (0, $le5ya.default)([
    [
        [
            [
                -5000000,
                12e6,
                0
            ],
            [
                4e6,
                12e6,
                0
            ],
            [
                4e6,
                11.5e6,
                0
            ],
            [
                -5000000,
                11.5e6,
                0
            ],
            [
                -5000000,
                12e6,
                0
            ]
        ]
    ],
    [
        [
            [
                -5000000,
                11.5e6,
                1e6
            ],
            [
                4e6,
                11.5e6,
                1e6
            ],
            [
                4e6,
                11e6,
                1e6
            ],
            [
                -5000000,
                11e6,
                1e6
            ],
            [
                -5000000,
                11.5e6,
                1e6
            ]
        ]
    ]
]);
$927f48c83533ce78$var$cartographicRectangleGeometry2.set("olcs_polygon_kind", "rectangle");
const $927f48c83533ce78$var$cartographicRectangle2 = new (0, $dIG9p.default)({
    geometry: $927f48c83533ce78$var$cartographicRectangleGeometry2
});
$927f48c83533ce78$var$cartographicRectangle2.setStyle($927f48c83533ce78$var$cartographicRectangleStyle);
const $927f48c83533ce78$var$vectorLayer = new (0, $bdrRp.default)({
    style: $927f48c83533ce78$var$styleFunction,
    source: $927f48c83533ce78$var$vectorSource
});
const $927f48c83533ce78$var$vectorSource2 = new (0, $bnthu.default)({
    features: [
        $927f48c83533ce78$var$iconFeature,
        $927f48c83533ce78$var$textFeature,
        $927f48c83533ce78$var$cervinFeature,
        ...$927f48c83533ce78$var$modelFeatures,
        $927f48c83533ce78$var$cartographicRectangle,
        $927f48c83533ce78$var$cartographicRectangle2
    ]
});
const $927f48c83533ce78$var$vectorLayer2 = new (0, $bdrRp.default)({
    source: $927f48c83533ce78$var$vectorSource2
});
const $927f48c83533ce78$var$dragAndDropInteraction = new (0, $9b46bac5c293ebb3$export$2e2bcd8739ae039)({
    formatConstructors: [
        (0, $c7152e7ae8968a6e$export$2e2bcd8739ae039),
        (0, $l7vEP.default),
        (0, $a3eff48c5fdb69ef$export$2e2bcd8739ae039),
        (0, $1140dfbeee585f32$export$2e2bcd8739ae039),
        (0, $10d5bd550e039cbe$export$2e2bcd8739ae039)
    ]
});
const $927f48c83533ce78$var$map = new (0, $5DwXE.default)({
    interactions: (0, $jzydl.defaults)().extend([
        $927f48c83533ce78$var$dragAndDropInteraction
    ]),
    layers: [
        new (0, $4mWlF.default)({
            source: new (0, $9jDAx.default)()
        }),
        $927f48c83533ce78$var$vectorLayer,
        $927f48c83533ce78$var$vectorLayer2
    ],
    target: "map2d",
    controls: (0, $f3WAG.defaults)({
        attributionOptions: {
            collapsible: false
        }
    }),
    view: new (0, $9DiKA.default)({
        center: [
            0,
            0
        ],
        zoom: 2
    })
});
$927f48c83533ce78$var$dragAndDropInteraction.on("addfeatures", (event)=>{
    const vectorSource = new (0, $bnthu.default)({
        features: event.features,
        projection: event.projection
    });
    $927f48c83533ce78$var$map.getLayers().push(new (0, $bdrRp.default)({
        source: vectorSource,
        style: $927f48c83533ce78$var$styleFunction
    }));
    const view = $927f48c83533ce78$var$map.getView();
    view.fitExtent(vectorSource.getExtent(), /** @type {ol.Size} */ $927f48c83533ce78$var$map.getSize());
});
Cesium.Ion.defaultAccessToken = (0, $bV0pP.OLCS_ION_TOKEN);
const $927f48c83533ce78$var$ol3d = new (0, $cc3xD.default)({
    map: $927f48c83533ce78$var$map,
    target: "map3d"
});
const $927f48c83533ce78$var$scene = $927f48c83533ce78$var$ol3d.getCesiumScene();
Cesium.createWorldTerrainAsync().then((tp)=>$927f48c83533ce78$var$scene.terrainProvider = tp);
$927f48c83533ce78$var$ol3d.setEnabled(true);
const $927f48c83533ce78$var$csLabels = new Cesium.LabelCollection();
$927f48c83533ce78$var$csLabels.add({
    position: Cesium.Cartesian3.fromRadians(20, 20, 0),
    text: "Pre-existing primitive"
});
$927f48c83533ce78$var$scene.primitives.add($927f48c83533ce78$var$csLabels);
// Adding a feature after the layer has been synchronized.
$927f48c83533ce78$var$vectorSource.addFeature($927f48c83533ce78$var$theCircle);
let $927f48c83533ce78$var$hasTheVectorLayer = true;
window["addOrRemoveOneVectorLayer"] = function() {
    if ($927f48c83533ce78$var$hasTheVectorLayer) $927f48c83533ce78$var$map.getLayers().remove($927f48c83533ce78$var$vectorLayer);
    else $927f48c83533ce78$var$map.getLayers().insertAt(1, $927f48c83533ce78$var$vectorLayer);
    $927f48c83533ce78$var$hasTheVectorLayer = !$927f48c83533ce78$var$hasTheVectorLayer;
};
window["addOrRemoveOneFeature"] = function() {
    const found = $927f48c83533ce78$var$vectorSource2.getFeatures().indexOf($927f48c83533ce78$var$iconFeature);
    if (found === -1) $927f48c83533ce78$var$vectorSource2.addFeature($927f48c83533ce78$var$iconFeature);
    else $927f48c83533ce78$var$vectorSource2.removeFeature($927f48c83533ce78$var$iconFeature);
};
let $927f48c83533ce78$var$oldStyle = new (0, $c3RIb.default)({
    stroke: new (0, $lrKvI.default)({
        color: "blue",
        width: 2
    }),
    fill: new (0, $inIMS.default)({
        color: "green"
    })
});
window["toggleStyle"] = function() {
    const swap = $927f48c83533ce78$var$theCircle.getStyle();
    $927f48c83533ce78$var$theCircle.setStyle($927f48c83533ce78$var$oldStyle);
    $927f48c83533ce78$var$oldStyle = swap;
};
window["toggleClampToGround"] = function() {
    let altitudeMode;
    if (!$927f48c83533ce78$var$vectorLayer.get("altitudeMode")) altitudeMode = "clampToGround";
    $927f48c83533ce78$var$vectorLayer.set("altitudeMode", altitudeMode);
    $927f48c83533ce78$var$vectorLayer2.set("altitudeMode", altitudeMode);
    $927f48c83533ce78$var$map.removeLayer($927f48c83533ce78$var$vectorLayer);
    $927f48c83533ce78$var$map.removeLayer($927f48c83533ce78$var$vectorLayer2);
    $927f48c83533ce78$var$map.addLayer($927f48c83533ce78$var$vectorLayer);
    $927f48c83533ce78$var$map.addLayer($927f48c83533ce78$var$vectorLayer2);
};
window["setTargetFrameRate"] = function() {
    let fps;
    const fpsEl = document.querySelector("#framerate");
    if (fpsEl) {
        fps = Number(fpsEl.value);
        $927f48c83533ce78$var$ol3d.setTargetFrameRate(fps);
    }
};
window["ol3d"] = $927f48c83533ce78$var$ol3d;
window["scene"] = $927f48c83533ce78$var$scene;
document.getElementById("enable").addEventListener("click", ()=>$927f48c83533ce78$var$ol3d.setEnabled(!$927f48c83533ce78$var$ol3d.getEnabled()));
$927f48c83533ce78$var$ol3d.enableAutoRenderLoop();


//# sourceMappingURL=vectors.349b1c8f.js.map
